import { P as POSTMARK_SERVER_TOKEN, c as SMTP_FROM, d as SMTP_USER } from "./private.js";
import { P as PUBLIC_ICON_URL } from "./public.js";
import * as postmark from "postmark";
const emailVerificationTemplate = '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">\n<html lang="en" xmlns="http://www.w3.org/1999/xhtml">\n	<head>\n		<meta charset="UTF-8" />\n		<meta content="width=device-width, initial-scale=1" name="viewport" />\n		<meta name="x-apple-disable-message-reformatting" />\n		<meta content="IE=edge" http-equiv="X-UA-Compatible" />\n		<meta content="telephone=no" name="format-detection" />\n		<title>New message</title>\n		<!--[if (mso 16)]>\n			<style type="text/css">\n				a {\n					text-decoration: none;\n				}\n			</style>\n		<![endif]-->\n		<!--[if gte mso 9]>\n			<style>\n				sup {\n					font-size: 100% !important;\n				}\n			</style><!\n		[endif]-->\n		<!--[if gte mso 9]>\n			<xml>\n				<o:OfficeDocumentSettings>\n					<o:AllowPNG></o:AllowPNG>\n					<o:PixelsPerInch>96</o:PixelsPerInch>\n				</o:OfficeDocumentSettings>\n			</xml>\n		<![endif]-->\n		<!--[if !mso]>-->\n		<link\n			href="https://fonts.googleapis.com/css?family=Roboto:400,400i,700,700i"\n			rel="stylesheet"\n		/>\n		<!--<![endif]-->\n		<style type="text/css">\n			.rollover:hover .rollover-first {\n				max-height: 0 !important;\n				display: none !important;\n			}\n\n			.rollover:hover .rollover-second {\n				max-height: none !important;\n				display: inline-block !important;\n			}\n\n			.rollover div {\n				font-size: 0px;\n			}\n\n			u ~ div img + div > div {\n				display: none;\n			}\n\n			#outlook a {\n				padding: 0;\n			}\n\n			span.MsoHyperlink,\n			span.MsoHyperlinkFollowed {\n				color: inherit;\n				mso-style-priority: 99;\n			}\n\n			a.es-button {\n				mso-style-priority: 100 !important;\n				text-decoration: none !important;\n			}\n\n			a[x-apple-data-detectors] {\n				color: inherit !important;\n				text-decoration: none !important;\n				font-size: inherit !important;\n				font-family: inherit !important;\n				font-weight: inherit !important;\n				line-height: inherit !important;\n			}\n\n			.es-desk-hidden {\n				display: none;\n				float: left;\n				overflow: hidden;\n				width: 0;\n				max-height: 0;\n				line-height: 0;\n				mso-hide: all;\n			}\n\n			/*\n  .es-header-body a:hover {\n	color:#2cb543!important;\n	}\n  */\n			/*\n  .es-content-body a:hover {\n	color:#2cb543!important;\n	}\n  */\n			/*\n  .es-footer-body a:hover {\n	color:#ffffff!important;\n	}\n  */\n			/*\n  .es-infoblock a:hover {\n	color:#cccccc!important;\n	}\n  */\n			.es-button-border:hover {\n				border-color: #42d159 #42d159 #42d159 #42d159 !important;\n				background: #56d66b !important;\n			}\n\n			.es-button-border:hover a.es-button,\n			.es-button-border:hover button.es-button {\n				background: #56d66b !important;\n			}\n\n			@media only screen and (max-width: 600px) {\n				.es-m-p35r {\n					padding-right: 35px !important;\n				}\n\n				.es-m-p35l {\n					padding-left: 35px !important;\n				}\n\n				*[class="gmail-fix"] {\n					display: none !important;\n				}\n\n				p,\n				a {\n					line-height: 150% !important;\n				}\n\n				h1,\n				h1 a {\n					line-height: 120% !important;\n				}\n\n				h2,\n				h2 a {\n					line-height: 120% !important;\n				}\n\n				h3,\n				h3 a {\n					line-height: 120% !important;\n				}\n\n				h4,\n				h4 a {\n					line-height: 120% !important;\n				}\n\n				h5,\n				h5 a {\n					line-height: 120% !important;\n				}\n\n				h6,\n				h6 a {\n					line-height: 120% !important;\n				}\n\n				.es-header-body p {\n				}\n\n				.es-content-body p {\n				}\n\n				.es-footer-body p {\n				}\n\n				.es-infoblock p {\n				}\n\n				h1 {\n					font-size: 30px !important;\n					text-align: left;\n				}\n\n				h2 {\n					font-size: 24px !important;\n					text-align: left;\n				}\n\n				h3 {\n					font-size: 20px !important;\n					text-align: left;\n				}\n\n				h4 {\n					font-size: 24px !important;\n					text-align: left;\n				}\n\n				h5 {\n					font-size: 20px !important;\n					text-align: left;\n				}\n\n				h6 {\n					font-size: 16px !important;\n					text-align: left;\n				}\n\n				.es-header-body h1 a,\n				.es-content-body h1 a,\n				.es-footer-body h1 a {\n					font-size: 30px !important;\n				}\n\n				.es-header-body h2 a,\n				.es-content-body h2 a,\n				.es-footer-body h2 a {\n					font-size: 24px !important;\n				}\n\n				.es-header-body h3 a,\n				.es-content-body h3 a,\n				.es-footer-body h3 a {\n					font-size: 20px !important;\n				}\n\n				.es-header-body h4 a,\n				.es-content-body h4 a,\n				.es-footer-body h4 a {\n					font-size: 24px !important;\n				}\n\n				.es-header-body h5 a,\n				.es-content-body h5 a,\n				.es-footer-body h5 a {\n					font-size: 20px !important;\n				}\n\n				.es-header-body h6 a,\n				.es-content-body h6 a,\n				.es-footer-body h6 a {\n					font-size: 16px !important;\n				}\n\n				.es-menu td a {\n					font-size: 14px !important;\n				}\n\n				.es-header-body p,\n				.es-header-body a {\n					font-size: 14px !important;\n				}\n\n				.es-content-body p,\n				.es-content-body a {\n					font-size: 14px !important;\n				}\n\n				.es-footer-body p,\n				.es-footer-body a {\n					font-size: 14px !important;\n				}\n\n				.es-infoblock p,\n				.es-infoblock a {\n					font-size: 12px !important;\n				}\n\n				.es-m-txt-c,\n				.es-m-txt-c h1,\n				.es-m-txt-c h2,\n				.es-m-txt-c h3,\n				.es-m-txt-c h4,\n				.es-m-txt-c h5,\n				.es-m-txt-c h6 {\n					text-align: center !important;\n				}\n\n				.es-m-txt-r,\n				.es-m-txt-r h1,\n				.es-m-txt-r h2,\n				.es-m-txt-r h3,\n				.es-m-txt-r h4,\n				.es-m-txt-r h5,\n				.es-m-txt-r h6 {\n					text-align: right !important;\n				}\n\n				.es-m-txt-j,\n				.es-m-txt-j h1,\n				.es-m-txt-j h2,\n				.es-m-txt-j h3,\n				.es-m-txt-j h4,\n				.es-m-txt-j h5,\n				.es-m-txt-j h6 {\n					text-align: justify !important;\n				}\n\n				.es-m-txt-l,\n				.es-m-txt-l h1,\n				.es-m-txt-l h2,\n				.es-m-txt-l h3,\n				.es-m-txt-l h4,\n				.es-m-txt-l h5,\n				.es-m-txt-l h6 {\n					text-align: left !important;\n				}\n\n				.es-m-txt-r img,\n				.es-m-txt-c img,\n				.es-m-txt-l img,\n				.es-m-txt-r .rollover:hover .rollover-second,\n				.es-m-txt-c .rollover:hover .rollover-second,\n				.es-m-txt-l .rollover:hover .rollover-second {\n					display: inline !important;\n				}\n\n				.es-m-txt-r .rollover div,\n				.es-m-txt-c .rollover div,\n				.es-m-txt-l .rollover div {\n					line-height: 0 !important;\n					font-size: 0 !important;\n				}\n\n				.es-spacer {\n					display: inline-table;\n				}\n\n				a.es-button,\n				button.es-button {\n					font-size: 18px !important;\n				}\n\n				.es-m-fw,\n				.es-m-fw.es-fw,\n				.es-m-fw .es-button {\n					display: block !important;\n				}\n\n				.es-m-il,\n				.es-m-il .es-button,\n				.es-social,\n				.es-social td,\n				.es-menu {\n					display: inline-block !important;\n				}\n\n				.es-adaptive table,\n				.es-left,\n				.es-right {\n					width: 100% !important;\n				}\n\n				.es-content table,\n				.es-header table,\n				.es-footer table,\n				.es-content,\n				.es-footer,\n				.es-header {\n					width: 100% !important;\n					max-width: 600px !important;\n				}\n\n				.adapt-img:not([src*="default-img"]) {\n					width: 100% !important;\n					height: auto !important;\n				}\n\n				.es-mobile-hidden,\n				.es-hidden {\n					display: none !important;\n				}\n\n				.es-desk-hidden {\n					width: auto !important;\n					overflow: visible !important;\n					float: none !important;\n					max-height: inherit !important;\n					line-height: inherit !important;\n				}\n\n				tr.es-desk-hidden {\n					display: table-row !important;\n				}\n\n				table.es-desk-hidden {\n					display: table !important;\n				}\n\n				td.es-desk-menu-hidden {\n					display: table-cell !important;\n				}\n\n				.es-menu td {\n					width: 1% !important;\n				}\n\n				table.es-table-not-adapt,\n				.esd-block-html table {\n					width: auto !important;\n				}\n\n				.es-social td {\n					padding-bottom: 10px;\n				}\n\n				.es-text-3309,\n				.es-text-3309 p,\n				.es-text-3309 a,\n				.es-text-3309 h1,\n				.es-text-3309 h2,\n				.es-text-3309 h3,\n				.es-text-3309 h4,\n				.es-text-3309 h5,\n				.es-text-3309 h6,\n				.es-text-3309 ul,\n				.es-text-3309 ol {\n					font-size: 20px !important;\n				}\n\n				a.es-button,\n				button.es-button {\n					display: inline-block !important;\n				}\n\n				.es-button-border {\n					display: inline-block !important;\n				}\n			}\n		</style>\n	</head>\n	<body style="width: 100%; height: 100%; padding: 0; margin: 0">\n		<div class="es-wrapper-color" style="background-color: #ffffff">\n			<!--[if gte mso 9]>\n				<v:background xmlns:v="urn:schemas-microsoft-com:vml" fill="t">\n					<v:fill type="tile" color="#FFFFFF"></v:fill>\n				</v:background>\n			<![endif]-->\n			<table\n				cellpadding="0"\n				cellspacing="0"\n				class="es-wrapper"\n				style="\n					mso-table-lspace: 0pt;\n					mso-table-rspace: 0pt;\n					border-collapse: collapse;\n					border-spacing: 0px;\n					padding: 0;\n					margin: 0;\n					width: 100%;\n					height: 100%;\n					background-repeat: repeat;\n					background-position: center top;\n					background-color: #ffffff;\n				"\n				width="100%"\n			>\n				<tr>\n					<td style="padding: 0; margin: 0" valign="top">\n						<table\n							align="center"\n							cellpadding="0"\n							cellspacing="0"\n							class="es-content"\n							style="\n								mso-table-lspace: 0pt;\n								mso-table-rspace: 0pt;\n								border-collapse: collapse;\n								border-spacing: 0px;\n								width: 100%;\n								table-layout: fixed !important;\n							"\n						>\n							<tr>\n								<td\n									align="center"\n									bgcolor="transparent"\n									style="padding: 0; margin: 0"\n								>\n									<table\n										align="center"\n										bgcolor="#ffffff"\n										cellpadding="0"\n										cellspacing="0"\n										class="es-content-body"\n										style="\n											mso-table-lspace: 0pt;\n											mso-table-rspace: 0pt;\n											border-collapse: collapse;\n											border-spacing: 0px;\n											background-color: #ffffff;\n											width: 600px;\n										"\n									>\n										<tr>\n											<td\n												align="left"\n												style="\n													padding: 0;\n													margin: 0;\n													padding-top: 20px;\n													padding-right: 20px;\n													padding-left: 20px;\n												"\n											>\n												<table\n													cellpadding="0"\n													cellspacing="0"\n													style="\n														mso-table-lspace: 0pt;\n														mso-table-rspace: 0pt;\n														border-collapse: collapse;\n														border-spacing: 0px;\n													"\n												>\n													<tr>\n														<td\n															align="left"\n															style="\n																padding: 0;\n																margin: 0;\n																width: 560px;\n															"\n														>\n															<table\n																cellpadding="0"\n																cellspacing="0"\n																role="presentation"\n																style="\n																	mso-table-lspace: 0pt;\n																	mso-table-rspace: 0pt;\n																	border-collapse: collapse;\n																	border-spacing: 0px;\n																"\n																width="100%"\n															>\n																<tr>\n																	<td\n																		align="center"\n																		style="\n																			padding: 0;\n																			margin: 0;\n																			padding-top: 5px;\n																			padding-bottom: 10px;\n																			font-size: 0;\n																		"\n																	>\n																		<img\n																			alt=""\n																			src="https://glimmr.app/images/icon.png"\n																			style="\n																				display: block;\n																				font-size: 14px;\n																				border: 0;\n																				outline: none;\n																				text-decoration: none;\n																				border-radius: 50px;\n																			"\n																			width="100"\n																		/>\n																	</td>\n																</tr>\n																<tr>\n																	<td\n																		align="center"\n																		style="\n																			padding: 20px;\n																			margin: 0;\n																			font-size: 0;\n																		"\n																	>\n																		<table\n																			border="0"\n																			cellpadding="0"\n																			cellspacing="0"\n																			class="es-spacer"\n																			height="100%"\n																			role="presentation"\n																			style="\n																				mso-table-lspace: 0pt;\n																				mso-table-rspace: 0pt;\n																				border-collapse: collapse;\n																				border-spacing: 0px;\n																			"\n																			width="100%"\n																		>\n																			<tr>\n																				<td\n																					style="\n																						padding: 0;\n																						margin: 0;\n																						border-bottom: 1px\n																							solid\n																							#cccccc;\n																						background: none;\n																						height: 1px;\n																						width: 100%;\n																						margin: 0px;\n																					"\n																				></td>\n																			</tr>\n																		</table>\n																	</td>\n																</tr>\n															</table>\n														</td>\n													</tr>\n												</table>\n											</td>\n										</tr>\n									</table>\n								</td>\n							</tr>\n						</table>\n						<table\n							align="center"\n							cellpadding="0"\n							cellspacing="0"\n							class="es-content"\n							style="\n								mso-table-lspace: 0pt;\n								mso-table-rspace: 0pt;\n								border-collapse: collapse;\n								border-spacing: 0px;\n								width: 100%;\n								table-layout: fixed !important;\n							"\n						>\n							<tr>\n								<td\n									align="center"\n									bgcolor="transparent"\n									style="padding: 0; margin: 0"\n								>\n									<table\n										align="center"\n										bgcolor="#ffffff"\n										cellpadding="0"\n										cellspacing="0"\n										class="es-content-body"\n										style="\n											mso-table-lspace: 0pt;\n											mso-table-rspace: 0pt;\n											border-collapse: collapse;\n											border-spacing: 0px;\n											background-color: #ffffff;\n											width: 600px;\n										"\n									>\n										<tr>\n											<td\n												align="left"\n												style="\n													padding: 0;\n													margin: 0;\n													padding-top: 20px;\n													padding-right: 20px;\n													padding-left: 20px;\n												"\n											>\n												<table\n													cellpadding="0"\n													cellspacing="0"\n													style="\n														mso-table-lspace: 0pt;\n														mso-table-rspace: 0pt;\n														border-collapse: collapse;\n														border-spacing: 0px;\n													"\n												>\n													<tr>\n														<td\n															align="left"\n															style="\n																padding: 0;\n																margin: 0;\n																width: 560px;\n															"\n														>\n															<table\n																cellpadding="0"\n																cellspacing="0"\n																role="presentation"\n																style="\n																	mso-table-lspace: 0pt;\n																	mso-table-rspace: 0pt;\n																	border-collapse: collapse;\n																	border-spacing: 0px;\n																"\n																width="100%"\n															>\n																<tr>\n																	<td\n																		align="center"\n																		class="es-m-txt-c"\n																		style="\n																			padding: 0;\n																			margin: 0;\n																		"\n																	>\n																		<h2\n																			style="\n																				margin: 0;\n																				font-family: roboto,\n																					&quot;helvetica neue&quot;,\n																					helvetica,\n																					arial,\n																					sans-serif;\n																				mso-line-height-rule: exactly;\n																				letter-spacing: 0;\n																				font-size: 24px;\n																				font-style: normal;\n																				font-weight: normal;\n																				line-height: 29px;\n																				color: #333333;\n																			"\n																		>\n																			<strong\n																				>Verify Your\n																				Email</strong\n																			>\n																		</h2>\n																	</td>\n																</tr>\n															</table>\n														</td>\n													</tr>\n													<tr>\n														<td\n															align="left"\n															style="\n																padding: 0;\n																margin: 0;\n																width: 560px;\n															"\n														>\n															<table\n																cellpadding="0"\n																cellspacing="0"\n																role="presentation"\n																style="\n																	mso-table-lspace: 0pt;\n																	mso-table-rspace: 0pt;\n																	border-collapse: collapse;\n																	border-spacing: 0px;\n																"\n																width="100%"\n															>\n																<tr>\n																	<td\n																		align="center"\n																		class="es-text-3309 es-m-txt-c"\n																		style="\n																			padding: 0;\n																			margin: 0;\n																			padding-top: 5px;\n																			font-size: 20px;\n																		"\n																	>\n																		<p\n																			style="\n																				margin: 0;\n																				mso-line-height-rule: exactly;\n																				font-family: roboto,\n																					&quot;helvetica neue&quot;,\n																					helvetica,\n																					arial,\n																					sans-serif;\n																				line-height: 34px !important;\n																				letter-spacing: 0;\n																				color: #666666;\n																				font-size: 20px;\n																			"\n																		>\n																			Hi there,\n																		</p>\n																		<p\n																			style="\n																				margin: 0;\n																				mso-line-height-rule: exactly;\n																				font-family: roboto,\n																					&quot;helvetica neue&quot;,\n																					helvetica,\n																					arial,\n																					sans-serif;\n																				line-height: 34px !important;\n																				letter-spacing: 0;\n																				color: #666666;\n																				font-size: 20px;\n																			"\n																		>\n																			This is your one time\n																			verification code. It\n																			expires in approximately\n																			5 minutes.\n																		</p>\n																	</td>\n																</tr>\n															</table>\n														</td>\n													</tr>\n												</table>\n											</td>\n										</tr>\n									</table>\n								</td>\n							</tr>\n						</table>\n						<table\n							align="center"\n							cellpadding="0"\n							cellspacing="0"\n							class="es-content"\n							style="\n								mso-table-lspace: 0pt;\n								mso-table-rspace: 0pt;\n								border-collapse: collapse;\n								border-spacing: 0px;\n								width: 100%;\n								table-layout: fixed !important;\n							"\n						>\n							<tr>\n								<td\n									align="center"\n									bgcolor="transparent"\n									style="padding: 0; margin: 0"\n								>\n									<table\n										align="center"\n										bgcolor="#ffffff"\n										cellpadding="0"\n										cellspacing="0"\n										class="es-content-body"\n										style="\n											mso-table-lspace: 0pt;\n											mso-table-rspace: 0pt;\n											border-collapse: collapse;\n											border-spacing: 0px;\n											background-color: #ffffff;\n											width: 600px;\n										"\n									>\n										<tr>\n											<td\n												align="left"\n												style="\n													padding: 0;\n													margin: 0;\n													padding-top: 20px;\n													padding-right: 20px;\n													padding-left: 20px;\n												"\n											>\n												<table\n													align="right"\n													cellpadding="0"\n													cellspacing="0"\n													class="es-right"\n													style="\n														mso-table-lspace: 0pt;\n														mso-table-rspace: 0pt;\n														border-collapse: collapse;\n														border-spacing: 0px;\n														float: right;\n													"\n												>\n													<tr>\n														<td\n															align="left"\n															style="\n																padding: 0;\n																margin: 0;\n																width: 560px;\n															"\n														>\n															<table\n																cellpadding="0"\n																cellspacing="0"\n																role="presentation"\n																style="\n																	mso-table-lspace: 0pt;\n																	mso-table-rspace: 0pt;\n																	border-collapse: collapse;\n																	border-spacing: 0px;\n																"\n																width="100%"\n															>\n																<tr>\n																	<td\n																		align="center"\n																		bgcolor="#f2fcff"\n																		class="es-m-p35l es-m-p35r es-m-txt-c"\n																		style="\n																			margin: 0;\n																			padding-top: 25px;\n																			padding-right: 30px;\n																			padding-bottom: 25px;\n																			padding-left: 30px;\n																			border-radius: 1rem;\n																		"\n																	>\n																		<h1\n																			style="\n																				margin: 0;\n																				font-family: roboto,\n																					&quot;helvetica neue&quot;,\n																					helvetica,\n																					arial,\n																					sans-serif;\n																				mso-line-height-rule: exactly;\n																				letter-spacing: 0;\n																				font-size: 30px;\n																				font-style: normal;\n																				font-weight: normal;\n																				line-height: 30px !important;\n																				color: #123533;\n																			"\n																		>\n																			<strong\n																				>{{ code }}</strong\n																			>\n																		</h1>\n																	</td>\n																</tr>\n																<tr>\n																	<td\n																		align="center"\n																		style="\n																			margin: 0;\n																			padding-right: 20px;\n																			padding-left: 20px;\n																			padding-top: 35px;\n																			padding-bottom: 20px;\n																			font-size: 0;\n																		"\n																	>\n																		<table\n																			border="0"\n																			cellpadding="0"\n																			cellspacing="0"\n																			class="es-spacer"\n																			height="100%"\n																			role="presentation"\n																			style="\n																				mso-table-lspace: 0pt;\n																				mso-table-rspace: 0pt;\n																				border-collapse: collapse;\n																				border-spacing: 0px;\n																			"\n																			width="100%"\n																		>\n																			<tr>\n																				<td\n																					style="\n																						padding: 0;\n																						margin: 0;\n																						border-bottom: 1px\n																							solid\n																							#cccccc;\n																						background: none;\n																						height: 1px;\n																						width: 100%;\n																						margin: 0px;\n																					"\n																				></td>\n																			</tr>\n																		</table>\n																	</td>\n																</tr>\n															</table>\n														</td>\n													</tr>\n												</table>\n											</td>\n										</tr>\n									</table>\n								</td>\n							</tr>\n						</table>\n						<table\n							align="center"\n							cellpadding="0"\n							cellspacing="0"\n							class="es-content"\n							style="\n								mso-table-lspace: 0pt;\n								mso-table-rspace: 0pt;\n								border-collapse: collapse;\n								border-spacing: 0px;\n								width: 100%;\n								table-layout: fixed !important;\n							"\n						>\n							<tr>\n								<td\n									align="center"\n									bgcolor="transparent"\n									style="padding: 0; margin: 0"\n								>\n									<table\n										align="center"\n										bgcolor="#ffffff"\n										cellpadding="0"\n										cellspacing="0"\n										class="es-content-body"\n										style="\n											mso-table-lspace: 0pt;\n											mso-table-rspace: 0pt;\n											border-collapse: collapse;\n											border-spacing: 0px;\n											background-color: #ffffff;\n											width: 600px;\n										"\n									>\n										<tr>\n											<td\n												align="left"\n												style="\n													padding: 0;\n													margin: 0;\n													padding-top: 20px;\n													padding-right: 20px;\n													padding-left: 20px;\n												"\n											>\n												<table\n													cellpadding="0"\n													cellspacing="0"\n													style="\n														mso-table-lspace: 0pt;\n														mso-table-rspace: 0pt;\n														border-collapse: collapse;\n														border-spacing: 0px;\n													"\n												>\n													<tr>\n														<td\n															align="left"\n															style="\n																padding: 0;\n																margin: 0;\n																width: 560px;\n															"\n														>\n															<table\n																cellpadding="0"\n																cellspacing="0"\n																role="presentation"\n																style="\n																	mso-table-lspace: 0pt;\n																	mso-table-rspace: 0pt;\n																	border-collapse: collapse;\n																	border-spacing: 0px;\n																"\n																width="100%"\n															>\n																<tr>\n																	<td\n																		align="center"\n																		class="es-m-txt-c"\n																		style="\n																			padding: 0;\n																			margin: 0;\n																		"\n																	>\n																		<p\n																			style="\n																				margin: 0;\n																				mso-line-height-rule: exactly;\n																				font-family: roboto,\n																					&quot;helvetica neue&quot;,\n																					helvetica,\n																					arial,\n																					sans-serif;\n																				line-height: 21px;\n																				letter-spacing: 0;\n																				color: #333333;\n																				font-size: 14px;\n																			"\n																		>\n																			Questions? Email us at\n																			<a\n																				href="mailto:support@glimmr.app"\n																				style="\n																					mso-line-height-rule: exactly;\n																					text-decoration: underline;\n																					color: #19bcc2;\n																					font-size: 14px;\n																				"\n																				>support@glimmr.app</a\n																			>\n																		</p>\n																	</td>\n																</tr>\n															</table>\n														</td>\n													</tr>\n												</table>\n											</td>\n										</tr>\n									</table>\n								</td>\n							</tr>\n						</table>\n						<table\n							align="center"\n							cellpadding="0"\n							cellspacing="0"\n							class="es-content"\n							style="\n								mso-table-lspace: 0pt;\n								mso-table-rspace: 0pt;\n								border-collapse: collapse;\n								border-spacing: 0px;\n								width: 100%;\n								table-layout: fixed !important;\n							"\n						>\n							<tr>\n								<td\n									align="center"\n									bgcolor="transparent"\n									style="padding: 0; margin: 0"\n								>\n									<table\n										align="center"\n										bgcolor="#ffffff"\n										cellpadding="0"\n										cellspacing="0"\n										class="es-content-body"\n										style="\n											mso-table-lspace: 0pt;\n											mso-table-rspace: 0pt;\n											border-collapse: collapse;\n											border-spacing: 0px;\n											background-color: #ffffff;\n											width: 600px;\n										"\n									>\n										<tr>\n											<td\n												align="left"\n												style="\n													padding: 0;\n													margin: 0;\n													padding-top: 20px;\n													padding-right: 20px;\n													padding-left: 20px;\n												"\n											>\n												<table\n													cellpadding="0"\n													cellspacing="0"\n													style="\n														mso-table-lspace: 0pt;\n														mso-table-rspace: 0pt;\n														border-collapse: collapse;\n														border-spacing: 0px;\n													"\n												>\n													<tr>\n														<td\n															align="left"\n															style="\n																padding: 0;\n																margin: 0;\n																width: 560px;\n															"\n														>\n															<table\n																cellpadding="0"\n																cellspacing="0"\n																style="\n																	mso-table-lspace: 0pt;\n																	mso-table-rspace: 0pt;\n																	border-collapse: collapse;\n																	border-spacing: 0px;\n																"\n																width="100%"\n															>\n																<tr>\n																	<td\n																		align="center"\n																		style="\n																			padding: 0;\n																			margin: 0;\n																			display: none;\n																		"\n																	></td>\n																</tr>\n															</table>\n														</td>\n													</tr>\n												</table>\n											</td>\n										</tr>\n									</table>\n								</td>\n							</tr>\n						</table>\n					</td>\n				</tr>\n			</table>\n		</div>\n	</body>\n</html>\n';
const licenseVerifiedTemplate = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html lang="en" xmlns="http://www.w3.org/1999/xhtml">
	<head>
		<meta charset="UTF-8" />
		<meta content="width=device-width, initial-scale=1" name="viewport" />
		<meta name="x-apple-disable-message-reformatting" />
		<meta content="IE=edge" http-equiv="X-UA-Compatible" />
		<meta content="telephone=no" name="format-detection" />
		<title>New message</title>
		<!--[if (mso 16)]>
			<style type="text/css">
				a {
					text-decoration: none;
				}
			</style>
		<![endif]-->
		<!--[if gte mso 9]>
			<style>
				sup {
					font-size: 100% !important;
				}
			</style><!
		[endif]-->
		<!--[if gte mso 9]>
			<xml>
				<o:OfficeDocumentSettings>
					<o:AllowPNG></o:AllowPNG>
					<o:PixelsPerInch>96</o:PixelsPerInch>
				</o:OfficeDocumentSettings>
			</xml>
		<![endif]-->
		<!--[if !mso]>-->
		<link
			href="https://fonts.googleapis.com/css?family=Roboto:400,400i,700,700i"
			rel="stylesheet"
		/>
		<!--<![endif]-->
		<style type="text/css">
			.rollover:hover .rollover-first {
				max-height: 0 !important;
				display: none !important;
			}

			.rollover:hover .rollover-second {
				max-height: none !important;
				display: inline-block !important;
			}

			.rollover div {
				font-size: 0px;
			}

			u ~ div img + div > div {
				display: none;
			}

			#outlook a {
				padding: 0;
			}

			span.MsoHyperlink,
			span.MsoHyperlinkFollowed {
				color: inherit;
				mso-style-priority: 99;
			}

			a.es-button {
				mso-style-priority: 100 !important;
				text-decoration: none !important;
			}

			a[x-apple-data-detectors] {
				color: inherit !important;
				text-decoration: none !important;
				font-size: inherit !important;
				font-family: inherit !important;
				font-weight: inherit !important;
				line-height: inherit !important;
			}

			.es-desk-hidden {
				display: none;
				float: left;
				overflow: hidden;
				width: 0;
				max-height: 0;
				line-height: 0;
				mso-hide: all;
			}

			/*
  .es-header-body a:hover {
	color:#2cb543!important;
	}
  */
			/*
  .es-content-body a:hover {
	color:#2cb543!important;
	}
  */
			/*
  .es-footer-body a:hover {
	color:#ffffff!important;
	}
  */
			/*
  .es-infoblock a:hover {
	color:#cccccc!important;
	}
  */
			.es-button-border:hover {
				border-color: #42d159 #42d159 #42d159 #42d159 !important;
				background: #56d66b !important;
			}

			.es-button-border:hover a.es-button,
			.es-button-border:hover button.es-button {
				background: #56d66b !important;
			}

			@media only screen and (max-width: 600px) {
				.es-m-p35r {
					padding-right: 35px !important;
				}

				.es-m-p35l {
					padding-left: 35px !important;
				}

				*[class="gmail-fix"] {
					display: none !important;
				}

				p,
				a {
					line-height: 150% !important;
				}

				h1,
				h1 a {
					line-height: 120% !important;
				}

				h2,
				h2 a {
					line-height: 120% !important;
				}

				h3,
				h3 a {
					line-height: 120% !important;
				}

				h4,
				h4 a {
					line-height: 120% !important;
				}

				h5,
				h5 a {
					line-height: 120% !important;
				}

				h6,
				h6 a {
					line-height: 120% !important;
				}

				.es-header-body p {
				}

				.es-content-body p {
				}

				.es-footer-body p {
				}

				.es-infoblock p {
				}

				h1 {
					font-size: 30px !important;
					text-align: left;
				}

				h2 {
					font-size: 24px !important;
					text-align: left;
				}

				h3 {
					font-size: 20px !important;
					text-align: left;
				}

				h4 {
					font-size: 24px !important;
					text-align: left;
				}

				h5 {
					font-size: 20px !important;
					text-align: left;
				}

				h6 {
					font-size: 16px !important;
					text-align: left;
				}

				.es-header-body h1 a,
				.es-content-body h1 a,
				.es-footer-body h1 a {
					font-size: 30px !important;
				}

				.es-header-body h2 a,
				.es-content-body h2 a,
				.es-footer-body h2 a {
					font-size: 24px !important;
				}

				.es-header-body h3 a,
				.es-content-body h3 a,
				.es-footer-body h3 a {
					font-size: 20px !important;
				}

				.es-header-body h4 a,
				.es-content-body h4 a,
				.es-footer-body h4 a {
					font-size: 24px !important;
				}

				.es-header-body h5 a,
				.es-content-body h5 a,
				.es-footer-body h5 a {
					font-size: 20px !important;
				}

				.es-header-body h6 a,
				.es-content-body h6 a,
				.es-footer-body h6 a {
					font-size: 16px !important;
				}

				.es-menu td a {
					font-size: 14px !important;
				}

				.es-header-body p,
				.es-header-body a {
					font-size: 14px !important;
				}

				.es-content-body p,
				.es-content-body a {
					font-size: 14px !important;
				}

				.es-footer-body p,
				.es-footer-body a {
					font-size: 14px !important;
				}

				.es-infoblock p,
				.es-infoblock a {
					font-size: 12px !important;
				}

				.es-m-txt-c,
				.es-m-txt-c h1,
				.es-m-txt-c h2,
				.es-m-txt-c h3,
				.es-m-txt-c h4,
				.es-m-txt-c h5,
				.es-m-txt-c h6 {
					text-align: center !important;
				}

				.es-m-txt-r,
				.es-m-txt-r h1,
				.es-m-txt-r h2,
				.es-m-txt-r h3,
				.es-m-txt-r h4,
				.es-m-txt-r h5,
				.es-m-txt-r h6 {
					text-align: right !important;
				}

				.es-m-txt-j,
				.es-m-txt-j h1,
				.es-m-txt-j h2,
				.es-m-txt-j h3,
				.es-m-txt-j h4,
				.es-m-txt-j h5,
				.es-m-txt-j h6 {
					text-align: justify !important;
				}

				.es-m-txt-l,
				.es-m-txt-l h1,
				.es-m-txt-l h2,
				.es-m-txt-l h3,
				.es-m-txt-l h4,
				.es-m-txt-l h5,
				.es-m-txt-l h6 {
					text-align: left !important;
				}

				.es-m-txt-r img,
				.es-m-txt-c img,
				.es-m-txt-l img,
				.es-m-txt-r .rollover:hover .rollover-second,
				.es-m-txt-c .rollover:hover .rollover-second,
				.es-m-txt-l .rollover:hover .rollover-second {
					display: inline !important;
				}

				.es-m-txt-r .rollover div,
				.es-m-txt-c .rollover div,
				.es-m-txt-l .rollover div {
					line-height: 0 !important;
					font-size: 0 !important;
				}

				.es-spacer {
					display: inline-table;
				}

				a.es-button,
				button.es-button {
					font-size: 18px !important;
				}

				.es-m-fw,
				.es-m-fw.es-fw,
				.es-m-fw .es-button {
					display: block !important;
				}

				.es-m-il,
				.es-m-il .es-button,
				.es-social,
				.es-social td,
				.es-menu {
					display: inline-block !important;
				}

				.es-adaptive table,
				.es-left,
				.es-right {
					width: 100% !important;
				}

				.es-content table,
				.es-header table,
				.es-footer table,
				.es-content,
				.es-footer,
				.es-header {
					width: 100% !important;
					max-width: 600px !important;
				}

				.adapt-img:not([src*="default-img"]) {
					width: 100% !important;
					height: auto !important;
				}

				.es-mobile-hidden,
				.es-hidden {
					display: none !important;
				}

				.es-desk-hidden {
					width: auto !important;
					overflow: visible !important;
					float: none !important;
					max-height: inherit !important;
					line-height: inherit !important;
				}

				tr.es-desk-hidden {
					display: table-row !important;
				}

				table.es-desk-hidden {
					display: table !important;
				}

				td.es-desk-menu-hidden {
					display: table-cell !important;
				}

				.es-menu td {
					width: 1% !important;
				}

				table.es-table-not-adapt,
				.esd-block-html table {
					width: auto !important;
				}

				.es-social td {
					padding-bottom: 10px;
				}

				.es-text-3309,
				.es-text-3309 p,
				.es-text-3309 a,
				.es-text-3309 h1,
				.es-text-3309 h2,
				.es-text-3309 h3,
				.es-text-3309 h4,
				.es-text-3309 h5,
				.es-text-3309 h6,
				.es-text-3309 ul,
				.es-text-3309 ol {
					font-size: 20px !important;
				}

				a.es-button,
				button.es-button {
					display: inline-block !important;
				}

				.es-button-border {
					display: inline-block !important;
				}
			}
		</style>
	</head>
	<body style="width: 100%; height: 100%; padding: 0; margin: 0">
		<div class="es-wrapper-color" style="background-color: #ffffff">
			<!--[if gte mso 9]>
				<v:background xmlns:v="urn:schemas-microsoft-com:vml" fill="t">
					<v:fill type="tile" color="#FFFFFF"></v:fill>
				</v:background>
			<![endif]-->
			<table
				cellpadding="0"
				cellspacing="0"
				class="es-wrapper"
				style="
					mso-table-lspace: 0pt;
					mso-table-rspace: 0pt;
					border-collapse: collapse;
					border-spacing: 0px;
					padding: 0;
					margin: 0;
					width: 100%;
					height: 100%;
					background-repeat: repeat;
					background-position: center top;
					background-color: #ffffff;
				"
				width="100%"
			>
				<tr>
					<td style="padding: 0; margin: 0" valign="top">
						<table
							align="center"
							cellpadding="0"
							cellspacing="0"
							class="es-content"
							style="
								mso-table-lspace: 0pt;
								mso-table-rspace: 0pt;
								border-collapse: collapse;
								border-spacing: 0px;
								width: 100%;
								table-layout: fixed !important;
							"
						>
							<tr>
								<td
									align="center"
									bgcolor="transparent"
									style="padding: 0; margin: 0"
								>
									<table
										align="center"
										bgcolor="#ffffff"
										cellpadding="0"
										cellspacing="0"
										class="es-content-body"
										style="
											mso-table-lspace: 0pt;
											mso-table-rspace: 0pt;
											border-collapse: collapse;
											border-spacing: 0px;
											background-color: #ffffff;
											width: 600px;
										"
									>
										<tr>
											<td
												align="left"
												style="
													padding: 0;
													margin: 0;
													padding-top: 20px;
													padding-right: 20px;
													padding-left: 20px;
												"
											>
												<table
													cellpadding="0"
													cellspacing="0"
													style="
														mso-table-lspace: 0pt;
														mso-table-rspace: 0pt;
														border-collapse: collapse;
														border-spacing: 0px;
													"
												>
													<tr>
														<td
															align="left"
															style="
																padding: 0;
																margin: 0;
																width: 560px;
															"
														>
															<table
																cellpadding="0"
																cellspacing="0"
																role="presentation"
																style="
																	mso-table-lspace: 0pt;
																	mso-table-rspace: 0pt;
																	border-collapse: collapse;
																	border-spacing: 0px;
																"
																width="100%"
															>
																<tr>
																	<td
																		align="center"
																		style="
																			padding: 0;
																			margin: 0;
																			padding-top: 5px;
																			padding-bottom: 10px;
																			font-size: 0;
																		"
																	>
																		<img
																			alt=""
																			src="https://glimmr.app/images/icon.png"
																			style="
																				display: block;
																				font-size: 14px;
																				border: 0;
																				outline: none;
																				text-decoration: none;
																				border-radius: 50px;
																			"
																			width="100"
																		/>
																	</td>
																</tr>
																<tr>
																	<td
																		align="center"
																		style="
																			padding: 20px;
																			margin: 0;
																			font-size: 0;
																		"
																	>
																		<table
																			border="0"
																			cellpadding="0"
																			cellspacing="0"
																			class="es-spacer"
																			height="100%"
																			role="presentation"
																			style="
																				mso-table-lspace: 0pt;
																				mso-table-rspace: 0pt;
																				border-collapse: collapse;
																				border-spacing: 0px;
																			"
																			width="100%"
																		>
																			<tr>
																				<td
																					style="
																						padding: 0;
																						margin: 0;
																						border-bottom: 1px
																							solid
																							#cccccc;
																						background: none;
																						height: 1px;
																						width: 100%;
																						margin: 0px;
																					"
																				></td>
																			</tr>
																		</table>
																	</td>
																</tr>
															</table>
														</td>
													</tr>
												</table>
											</td>
										</tr>
									</table>
								</td>
							</tr>
						</table>
						<table
							align="center"
							cellpadding="0"
							cellspacing="0"
							class="es-content"
							style="
								mso-table-lspace: 0pt;
								mso-table-rspace: 0pt;
								border-collapse: collapse;
								border-spacing: 0px;
								width: 100%;
								table-layout: fixed !important;
							"
						>
							<tr>
								<td
									align="center"
									bgcolor="transparent"
									style="padding: 0; margin: 0"
								>
									<table
										align="center"
										bgcolor="#ffffff"
										cellpadding="0"
										cellspacing="0"
										class="es-content-body"
										style="
											mso-table-lspace: 0pt;
											mso-table-rspace: 0pt;
											border-collapse: collapse;
											border-spacing: 0px;
											background-color: #ffffff;
											width: 600px;
										"
									>
										<tr>
											<td
												align="left"
												style="
													padding: 0;
													margin: 0;
													padding-top: 20px;
													padding-right: 20px;
													padding-left: 20px;
												"
											>
												<table
													cellpadding="0"
													cellspacing="0"
													style="
														mso-table-lspace: 0pt;
														mso-table-rspace: 0pt;
														border-collapse: collapse;
														border-spacing: 0px;
													"
												>
													<tr>
														<td
															align="left"
															style="
																padding: 0;
																margin: 0;
																width: 560px;
															"
														>
															<table
																cellpadding="0"
																cellspacing="0"
																role="presentation"
																style="
																	mso-table-lspace: 0pt;
																	mso-table-rspace: 0pt;
																	border-collapse: collapse;
																	border-spacing: 0px;
																"
																width="100%"
															>
																<tr>
																	<td
																		align="center"
																		class="es-m-txt-c"
																		style="
																			padding: 0;
																			margin: 0;
																		"
																	>
																		<h2
																			style="
																				margin: 0;
																				font-family: roboto,
																					&quot;helvetica neue&quot;,
																					helvetica,
																					arial,
																					sans-serif;
																				mso-line-height-rule: exactly;
																				letter-spacing: 0;
																				font-size: 24px;
																				font-style: normal;
																				font-weight: normal;
																				line-height: 29px;
																				color: #333333;
																			"
																		>
																			<strong
																				>License
																				Verified</strong
																			>
																		</h2>
																	</td>
																</tr>
															</table>
														</td>
													</tr>
													<tr>
														<td
															align="left"
															style="
																padding: 0;
																margin: 0;
																width: 560px;
															"
														>
															<table
																cellpadding="0"
																cellspacing="0"
																role="presentation"
																style="
																	mso-table-lspace: 0pt;
																	mso-table-rspace: 0pt;
																	border-collapse: collapse;
																	border-spacing: 0px;
																"
																width="100%"
															>
																<tr>
																	<td
																		align="center"
																		class="es-text-3309 es-m-txt-c"
																		style="
																			padding: 0;
																			margin: 0;
																			padding-top: 5px;
																			font-size: 20px;
																		"
																	>
																		<p
																			style="
																				margin: 0;
																				mso-line-height-rule: exactly;
																				font-family: roboto,
																					&quot;helvetica neue&quot;,
																					helvetica,
																					arial,
																					sans-serif;
																				line-height: 34px !important;
																				letter-spacing: 0;
																				color: #666666;
																				font-size: 20px;
																			"
																		>
																			Thank you for validating
																			your license! You're all
																			set. Please note that
																			you can use your license
																			on multiple devices. All
																			you need to do is repeat
																			the in-app activation
																			process on any new
																			device.
																		</p>
																	</td>
																</tr>
															</table>
														</td>
													</tr>
												</table>
											</td>
										</tr>
									</table>
								</td>
							</tr>
						</table>
						<table
							align="center"
							cellpadding="0"
							cellspacing="0"
							class="es-content"
							style="
								mso-table-lspace: 0pt;
								mso-table-rspace: 0pt;
								border-collapse: collapse;
								border-spacing: 0px;
								width: 100%;
								table-layout: fixed !important;
							"
						>
							<tr>
								<td
									align="center"
									bgcolor="transparent"
									style="padding: 0; margin: 0"
								>
									<table
										align="center"
										bgcolor="#ffffff"
										cellpadding="0"
										cellspacing="0"
										class="es-content-body"
										style="
											mso-table-lspace: 0pt;
											mso-table-rspace: 0pt;
											border-collapse: collapse;
											border-spacing: 0px;
											background-color: #ffffff;
											width: 600px;
										"
									>
										<tr>
											<td
												align="left"
												style="
													padding: 0;
													margin: 0;
													padding-top: 20px;
													padding-right: 20px;
													padding-left: 20px;
												"
											>
												<table
													cellpadding="0"
													cellspacing="0"
													style="
														mso-table-lspace: 0pt;
														mso-table-rspace: 0pt;
														border-collapse: collapse;
														border-spacing: 0px;
													"
												>
													<tr>
														<td
															align="left"
															style="
																padding: 0;
																margin: 0;
																width: 560px;
															"
														>
															<table
																cellpadding="0"
																cellspacing="0"
																role="presentation"
																style="
																	mso-table-lspace: 0pt;
																	mso-table-rspace: 0pt;
																	border-collapse: collapse;
																	border-spacing: 0px;
																"
																width="100%"
															>
																<tr>
																	<td
																		align="center"
																		class="es-m-txt-c"
																		style="
																			padding: 0;
																			margin: 0;
																		"
																	>
																		<p
																			style="
																				margin: 0;
																				mso-line-height-rule: exactly;
																				font-family: roboto,
																					&quot;helvetica neue&quot;,
																					helvetica,
																					arial,
																					sans-serif;
																				line-height: 21px;
																				letter-spacing: 0;
																				color: #333333;
																				font-size: 14px;
																			"
																		>
																			Questions? Email us at
																			<a
																				href="mailto:support@glimmr.app"
																				style="
																					mso-line-height-rule: exactly;
																					text-decoration: underline;
																					color: #19bcc2;
																					font-size: 14px;
																				"
																				>support@glimmr.app</a
																			>
																		</p>
																	</td>
																</tr>
															</table>
														</td>
													</tr>
												</table>
											</td>
										</tr>
									</table>
								</td>
							</tr>
						</table>
						<table
							align="center"
							cellpadding="0"
							cellspacing="0"
							class="es-content"
							style="
								mso-table-lspace: 0pt;
								mso-table-rspace: 0pt;
								border-collapse: collapse;
								border-spacing: 0px;
								width: 100%;
								table-layout: fixed !important;
							"
						>
							<tr>
								<td
									align="center"
									bgcolor="transparent"
									style="padding: 0; margin: 0"
								>
									<table
										align="center"
										bgcolor="#ffffff"
										cellpadding="0"
										cellspacing="0"
										class="es-content-body"
										style="
											mso-table-lspace: 0pt;
											mso-table-rspace: 0pt;
											border-collapse: collapse;
											border-spacing: 0px;
											background-color: #ffffff;
											width: 600px;
										"
									>
										<tr>
											<td
												align="left"
												style="
													padding: 0;
													margin: 0;
													padding-top: 20px;
													padding-right: 20px;
													padding-left: 20px;
												"
											>
												<table
													cellpadding="0"
													cellspacing="0"
													style="
														mso-table-lspace: 0pt;
														mso-table-rspace: 0pt;
														border-collapse: collapse;
														border-spacing: 0px;
													"
												>
													<tr>
														<td
															align="left"
															style="
																padding: 0;
																margin: 0;
																width: 560px;
															"
														>
															<table
																cellpadding="0"
																cellspacing="0"
																style="
																	mso-table-lspace: 0pt;
																	mso-table-rspace: 0pt;
																	border-collapse: collapse;
																	border-spacing: 0px;
																"
																width="100%"
															>
																<tr>
																	<td
																		align="center"
																		style="
																			padding: 0;
																			margin: 0;
																			display: none;
																		"
																	></td>
																</tr>
															</table>
														</td>
													</tr>
												</table>
											</td>
										</tr>
									</table>
								</td>
							</tr>
						</table>
					</td>
				</tr>
			</table>
		</div>
	</body>
</html>
`;
const licenseTemplate = '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">\n<html lang="en" xmlns="http://www.w3.org/1999/xhtml">\n	<head>\n		<meta charset="UTF-8" />\n		<meta content="width=device-width, initial-scale=1" name="viewport" />\n		<meta name="x-apple-disable-message-reformatting" />\n		<meta content="IE=edge" http-equiv="X-UA-Compatible" />\n		<meta content="telephone=no" name="format-detection" />\n		<title>New message</title>\n		<!--[if (mso 16)]>\n			<style type="text/css">\n				a {\n					text-decoration: none;\n				}\n			</style>\n		<![endif]-->\n		<!--[if gte mso 9]>\n			<style>\n				sup {\n					font-size: 100% !important;\n				}\n			</style><!\n		[endif]-->\n		<!--[if gte mso 9]>\n			<xml>\n				<o:OfficeDocumentSettings>\n					<o:AllowPNG></o:AllowPNG>\n					<o:PixelsPerInch>96</o:PixelsPerInch>\n				</o:OfficeDocumentSettings>\n			</xml>\n		<![endif]-->\n		<!--[if !mso]>-->\n		<link\n			href="https://fonts.googleapis.com/css?family=Roboto:400,400i,700,700i"\n			rel="stylesheet"\n		/>\n		<!--<![endif]-->\n		<style type="text/css">\n			.rollover:hover .rollover-first {\n				max-height: 0 !important;\n				display: none !important;\n			}\n\n			.rollover:hover .rollover-second {\n				max-height: none !important;\n				display: inline-block !important;\n			}\n\n			.rollover div {\n				font-size: 0px;\n			}\n\n			u ~ div img + div > div {\n				display: none;\n			}\n\n			#outlook a {\n				padding: 0;\n			}\n\n			span.MsoHyperlink,\n			span.MsoHyperlinkFollowed {\n				color: inherit;\n				mso-style-priority: 99;\n			}\n\n			a.es-button {\n				mso-style-priority: 100 !important;\n				text-decoration: none !important;\n			}\n\n			a[x-apple-data-detectors] {\n				color: inherit !important;\n				text-decoration: none !important;\n				font-size: inherit !important;\n				font-family: inherit !important;\n				font-weight: inherit !important;\n				line-height: inherit !important;\n			}\n\n			.es-desk-hidden {\n				display: none;\n				float: left;\n				overflow: hidden;\n				width: 0;\n				max-height: 0;\n				line-height: 0;\n				mso-hide: all;\n			}\n\n			.es-button-border:hover {\n				border-color: #42d159 #42d159 #42d159 #42d159 !important;\n				background: #56d66b !important;\n			}\n\n			.es-button-border:hover a.es-button,\n			.es-button-border:hover button.es-button {\n				background: #56d66b !important;\n			}\n\n			@media only screen and (max-width: 600px) {\n				.es-m-p35r {\n					padding-right: 35px !important;\n				}\n\n				.es-m-p35l {\n					padding-left: 35px !important;\n				}\n\n				*[class="gmail-fix"] {\n					display: none !important;\n				}\n\n				p,\n				a {\n					line-height: 150% !important;\n				}\n\n				h1,\n				h1 a {\n					line-height: 120% !important;\n				}\n\n				h2,\n				h2 a {\n					line-height: 120% !important;\n				}\n\n				h3,\n				h3 a {\n					line-height: 120% !important;\n				}\n\n				h4,\n				h4 a {\n					line-height: 120% !important;\n				}\n\n				h5,\n				h5 a {\n					line-height: 120% !important;\n				}\n\n				h6,\n				h6 a {\n					line-height: 120% !important;\n				}\n\n				h1 {\n					font-size: 30px !important;\n					text-align: left;\n				}\n\n				h2 {\n					font-size: 24px !important;\n					text-align: left;\n				}\n\n				h3 {\n					font-size: 20px !important;\n					text-align: left;\n				}\n\n				h4 {\n					font-size: 24px !important;\n					text-align: left;\n				}\n\n				h5 {\n					font-size: 20px !important;\n					text-align: left;\n				}\n\n				h6 {\n					font-size: 16px !important;\n					text-align: left;\n				}\n\n				.es-header-body h1 a,\n				.es-content-body h1 a,\n				.es-footer-body h1 a {\n					font-size: 30px !important;\n				}\n\n				.es-header-body h2 a,\n				.es-content-body h2 a,\n				.es-footer-body h2 a {\n					font-size: 24px !important;\n				}\n\n				.es-header-body h3 a,\n				.es-content-body h3 a,\n				.es-footer-body h3 a {\n					font-size: 20px !important;\n				}\n\n				.es-header-body h4 a,\n				.es-content-body h4 a,\n				.es-footer-body h4 a {\n					font-size: 24px !important;\n				}\n\n				.es-header-body h5 a,\n				.es-content-body h5 a,\n				.es-footer-body h5 a {\n					font-size: 20px !important;\n				}\n\n				.es-header-body h6 a,\n				.es-content-body h6 a,\n				.es-footer-body h6 a {\n					font-size: 16px !important;\n				}\n\n				.es-menu td a {\n					font-size: 14px !important;\n				}\n\n				.es-header-body p,\n				.es-header-body a {\n					font-size: 14px !important;\n				}\n\n				.es-content-body p,\n				.es-content-body a {\n					font-size: 14px !important;\n				}\n\n				.es-footer-body p,\n				.es-footer-body a {\n					font-size: 14px !important;\n				}\n\n				.es-infoblock p,\n				.es-infoblock a {\n					font-size: 12px !important;\n				}\n\n				.es-m-txt-c,\n				.es-m-txt-c h1,\n				.es-m-txt-c h2,\n				.es-m-txt-c h3,\n				.es-m-txt-c h4,\n				.es-m-txt-c h5,\n				.es-m-txt-c h6 {\n					text-align: center !important;\n				}\n\n				.es-m-txt-r,\n				.es-m-txt-r h1,\n				.es-m-txt-r h2,\n				.es-m-txt-r h3,\n				.es-m-txt-r h4,\n				.es-m-txt-r h5,\n				.es-m-txt-r h6 {\n					text-align: right !important;\n				}\n\n				.es-m-txt-j,\n				.es-m-txt-j h1,\n				.es-m-txt-j h2,\n				.es-m-txt-j h3,\n				.es-m-txt-j h4,\n				.es-m-txt-j h5,\n				.es-m-txt-j h6 {\n					text-align: justify !important;\n				}\n\n				.es-m-txt-l,\n				.es-m-txt-l h1,\n				.es-m-txt-l h2,\n				.es-m-txt-l h3,\n				.es-m-txt-l h4,\n				.es-m-txt-l h5,\n				.es-m-txt-l h6 {\n					text-align: left !important;\n				}\n\n				.es-m-txt-r img,\n				.es-m-txt-c img,\n				.es-m-txt-l img,\n				.es-m-txt-r .rollover:hover .rollover-second,\n				.es-m-txt-c .rollover:hover .rollover-second,\n				.es-m-txt-l .rollover:hover .rollover-second {\n					display: inline !important;\n				}\n\n				.es-m-txt-r .rollover div,\n				.es-m-txt-c .rollover div,\n				.es-m-txt-l .rollover div {\n					line-height: 0 !important;\n					font-size: 0 !important;\n				}\n\n				.es-spacer {\n					display: inline-table;\n				}\n\n				a.es-button,\n				button.es-button {\n					font-size: 18px !important;\n				}\n\n				.es-m-fw,\n				.es-m-fw.es-fw,\n				.es-m-fw .es-button {\n					display: block !important;\n				}\n\n				.es-m-il,\n				.es-m-il .es-button,\n				.es-social,\n				.es-social td,\n				.es-menu {\n					display: inline-block !important;\n				}\n\n				.es-adaptive table,\n				.es-left,\n				.es-right {\n					width: 100% !important;\n				}\n\n				.es-content table,\n				.es-header table,\n				.es-footer table,\n				.es-content,\n				.es-footer,\n				.es-header {\n					width: 100% !important;\n					max-width: 600px !important;\n				}\n\n				.adapt-img:not([src*="default-img"]) {\n					width: 100% !important;\n					height: auto !important;\n				}\n\n				.es-mobile-hidden,\n				.es-hidden {\n					display: none !important;\n				}\n\n				.es-desk-hidden {\n					width: auto !important;\n					overflow: visible !important;\n					float: none !important;\n					max-height: inherit !important;\n					line-height: inherit !important;\n				}\n\n				tr.es-desk-hidden {\n					display: table-row !important;\n				}\n\n				table.es-desk-hidden {\n					display: table !important;\n				}\n\n				td.es-desk-menu-hidden {\n					display: table-cell !important;\n				}\n\n				.es-menu td {\n					width: 1% !important;\n				}\n\n				table.es-table-not-adapt,\n				.esd-block-html table {\n					width: auto !important;\n				}\n\n				.es-social td {\n					padding-bottom: 10px;\n				}\n\n				.es-text-3309,\n				.es-text-3309 p,\n				.es-text-3309 a,\n				.es-text-3309 h1,\n				.es-text-3309 h2,\n				.es-text-3309 h3,\n				.es-text-3309 h4,\n				.es-text-3309 h5,\n				.es-text-3309 h6,\n				.es-text-3309 ul,\n				.es-text-3309 ol {\n					font-size: 20px !important;\n				}\n\n				a.es-button,\n				button.es-button {\n					display: inline-block !important;\n				}\n\n				.es-button-border {\n					display: inline-block !important;\n				}\n			}\n		</style>\n	</head>\n	<body style="width: 100%; height: 100%; padding: 0; margin: 0">\n		<div class="es-wrapper-color" style="background-color: #ffffff">\n			<!--[if gte mso 9]>\n				<v:background xmlns:v="urn:schemas-microsoft-com:vml" fill="t">\n					<v:fill type="tile" color="#FFFFFF"></v:fill>\n				</v:background>\n			<![endif]-->\n			<table\n				cellpadding="0"\n				cellspacing="0"\n				class="es-wrapper"\n				style="\n					mso-table-lspace: 0pt;\n					mso-table-rspace: 0pt;\n					border-collapse: collapse;\n					border-spacing: 0px;\n					padding: 0;\n					margin: 0;\n					width: 100%;\n					height: 100%;\n					background-repeat: repeat;\n					background-position: center top;\n					background-color: #ffffff;\n				"\n				width="100%"\n			>\n				<tr>\n					<td style="padding: 0; margin: 0" valign="top">\n						<!-- LOGO / HEADER -->\n						<table\n							align="center"\n							cellpadding="0"\n							cellspacing="0"\n							class="es-content"\n							style="\n								mso-table-lspace: 0pt;\n								mso-table-rspace: 0pt;\n								border-collapse: collapse;\n								border-spacing: 0px;\n								width: 100%;\n								table-layout: fixed !important;\n							"\n						>\n							<tr>\n								<td\n									align="center"\n									bgcolor="transparent"\n									style="padding: 0; margin: 0"\n								>\n									<table\n										align="center"\n										bgcolor="#ffffff"\n										cellpadding="0"\n										cellspacing="0"\n										class="es-content-body"\n										style="\n											mso-table-lspace: 0pt;\n											mso-table-rspace: 0pt;\n											border-collapse: collapse;\n											border-spacing: 0px;\n											background-color: #ffffff;\n											width: 600px;\n										"\n									>\n										<tr>\n											<td\n												align="left"\n												style="\n													padding: 0;\n													margin: 0;\n													padding-top: 20px;\n													padding-right: 20px;\n													padding-left: 20px;\n												"\n											>\n												<table\n													cellpadding="0"\n													cellspacing="0"\n													style="\n														mso-table-lspace: 0pt;\n														mso-table-rspace: 0pt;\n														border-collapse: collapse;\n														border-spacing: 0px;\n													"\n												>\n													<tr>\n														<td\n															align="left"\n															style="\n																padding: 0;\n																margin: 0;\n																width: 560px;\n															"\n														>\n															<table\n																cellpadding="0"\n																cellspacing="0"\n																role="presentation"\n																style="\n																	mso-table-lspace: 0pt;\n																	mso-table-rspace: 0pt;\n																	border-collapse: collapse;\n																	border-spacing: 0px;\n																"\n																width="100%"\n															>\n																<tr>\n																	<td\n																		align="center"\n																		style="\n																			padding: 0;\n																			margin: 0;\n																			padding-top: 5px;\n																			padding-bottom: 10px;\n																			font-size: 0;\n																		"\n																	>\n																		<img\n																			alt=""\n																			src="https://glimmr.app/images/icon.png"\n																			style="\n																				display: block;\n																				font-size: 14px;\n																				border: 0;\n																				outline: none;\n																				text-decoration: none;\n																				border-radius: 50px;\n																			"\n																			width="100"\n																		/>\n																	</td>\n																</tr>\n																<tr>\n																	<td\n																		align="center"\n																		style="\n																			padding: 20px;\n																			margin: 0;\n																			font-size: 0;\n																		"\n																	>\n																		<table\n																			border="0"\n																			cellpadding="0"\n																			cellspacing="0"\n																			class="es-spacer"\n																			height="100%"\n																			role="presentation"\n																			style="\n																				mso-table-lspace: 0pt;\n																				mso-table-rspace: 0pt;\n																				border-collapse: collapse;\n																				border-spacing: 0px;\n																			"\n																			width="100%"\n																		>\n																			<tr>\n																				<td\n																					style="\n																						padding: 0;\n																						margin: 0;\n																						border-bottom: 1px\n																							solid\n																							#cccccc;\n																						background: none;\n																						height: 1px;\n																						width: 100%;\n																						margin: 0px;\n																					"\n																				></td>\n																			</tr>\n																		</table>\n																	</td>\n																</tr>\n															</table>\n														</td>\n													</tr>\n												</table>\n											</td>\n										</tr>\n									</table>\n								</td>\n							</tr>\n						</table>\n\n						<!-- LICENSE INFORMATION TITLE & INTRO -->\n						<table\n							align="center"\n							cellpadding="0"\n							cellspacing="0"\n							class="es-content"\n							style="\n								mso-table-lspace: 0pt;\n								mso-table-rspace: 0pt;\n								border-collapse: collapse;\n								border-spacing: 0px;\n								width: 100%;\n								table-layout: fixed !important;\n							"\n						>\n							<tr>\n								<td\n									align="center"\n									bgcolor="transparent"\n									style="padding: 0; margin: 0"\n								>\n									<table\n										align="center"\n										bgcolor="#ffffff"\n										cellpadding="0"\n										cellspacing="0"\n										class="es-content-body"\n										style="\n											mso-table-lspace: 0pt;\n											mso-table-rspace: 0pt;\n											border-collapse: collapse;\n											border-spacing: 0px;\n											background-color: #ffffff;\n											width: 600px;\n										"\n									>\n										<tr>\n											<td\n												align="left"\n												style="\n													padding: 0;\n													margin: 0;\n													padding-top: 20px;\n													padding-right: 20px;\n													padding-left: 20px;\n												"\n											>\n												<table\n													cellpadding="0"\n													cellspacing="0"\n													style="\n														mso-table-lspace: 0pt;\n														mso-table-rspace: 0pt;\n														border-collapse: collapse;\n														border-spacing: 0px;\n													"\n												>\n													<tr>\n														<td\n															align="left"\n															style="\n																padding: 0;\n																margin: 0;\n																width: 560px;\n															"\n														>\n															<table\n																cellpadding="0"\n																cellspacing="0"\n																role="presentation"\n																style="\n																	mso-table-lspace: 0pt;\n																	mso-table-rspace: 0pt;\n																	border-collapse: collapse;\n																	border-spacing: 0px;\n																"\n																width="100%"\n															>\n																<!-- TITLE: LICENSE INFORMATION -->\n																<tr>\n																	<td\n																		align="center"\n																		class="es-m-txt-c"\n																		style="\n																			padding: 0;\n																			margin: 0;\n																		"\n																	>\n																		<h2\n																			style="\n																				margin: 0;\n																				font-family: roboto,\n																					&quot;helvetica neue&quot;,\n																					helvetica,\n																					arial,\n																					sans-serif;\n																				mso-line-height-rule: exactly;\n																				letter-spacing: 0;\n																				font-size: 24px;\n																				font-style: normal;\n																				font-weight: normal;\n																				line-height: 29px;\n																				color: #333333;\n																			"\n																		>\n																			<strong\n																				>License\n																				Information</strong\n																			>\n																		</h2>\n																	</td>\n																</tr>\n\n																<!-- OPTIONAL GREETING/THANK-YOU -->\n																<tr>\n																	<td\n																		align="center"\n																		class="es-text-3309 es-m-txt-c"\n																		style="\n																			padding: 0;\n																			margin: 0;\n																			padding-top: 5px;\n																			font-size: 20px;\n																		"\n																	>\n																		<p\n																			style="\n																				margin: 0;\n																				mso-line-height-rule: exactly;\n																				font-family: roboto,\n																					&quot;helvetica neue&quot;,\n																					helvetica,\n																					arial,\n																					sans-serif;\n																				line-height: 34px !important;\n																				letter-spacing: 0;\n																				color: #666666;\n																				font-size: 20px;\n																			"\n																		>\n																			{{ intro }} We truly\n																			appreciate your support\n																			and hope our software\n																			makes your life a little\n																			easier!\n																		</p>\n																	</td>\n																</tr>\n\n																<!-- INTRO TEXT -->\n																<tr>\n																	<td\n																		align="center"\n																		class="es-text-3309 es-m-txt-c"\n																		style="\n																			padding: 0;\n																			margin: 0;\n																			padding-top: 5px;\n																			font-size: 20px;\n																		"\n																	>\n																		<p\n																			style="\n																				margin: 0;\n																				mso-line-height-rule: exactly;\n																				font-family: roboto,\n																					&quot;helvetica neue&quot;,\n																					helvetica,\n																					arial,\n																					sans-serif;\n																				line-height: 34px !important;\n																				letter-spacing: 0;\n																				color: #666666;\n																				font-size: 20px;\n																			"\n																		>\n																			Please find your license\n																			below.\n																		</p>\n																	</td>\n																</tr>\n															</table>\n														</td>\n													</tr>\n												</table>\n											</td>\n										</tr>\n									</table>\n								</td>\n							</tr>\n						</table>\n\n						<!-- LICENSE CODE -->\n						<table\n							align="center"\n							cellpadding="0"\n							cellspacing="0"\n							class="es-content"\n							style="\n								mso-table-lspace: 0pt;\n								mso-table-rspace: 0pt;\n								border-collapse: collapse;\n								border-spacing: 0px;\n								width: 100%;\n								table-layout: fixed !important;\n							"\n						>\n							<tr>\n								<td\n									align="center"\n									bgcolor="transparent"\n									style="padding: 0; margin: 0"\n								>\n									<table\n										align="center"\n										bgcolor="#ffffff"\n										cellpadding="0"\n										cellspacing="0"\n										class="es-content-body"\n										style="\n											mso-table-lspace: 0pt;\n											mso-table-rspace: 0pt;\n											border-collapse: collapse;\n											border-spacing: 0px;\n											background-color: #ffffff;\n											width: 600px;\n										"\n									>\n										<tr>\n											<td\n												align="left"\n												style="\n													padding: 0;\n													margin: 0;\n													padding-top: 20px;\n													padding-right: 20px;\n													padding-left: 20px;\n												"\n											>\n												<table\n													align="right"\n													cellpadding="0"\n													cellspacing="0"\n													class="es-right"\n													style="\n														mso-table-lspace: 0pt;\n														mso-table-rspace: 0pt;\n														border-collapse: collapse;\n														border-spacing: 0px;\n														float: right;\n													"\n												>\n													<tr>\n														<td\n															align="left"\n															style="\n																padding: 0;\n																margin: 0;\n																width: 560px;\n															"\n														>\n															<table\n																cellpadding="0"\n																cellspacing="0"\n																role="presentation"\n																style="\n																	mso-table-lspace: 0pt;\n																	mso-table-rspace: 0pt;\n																	border-collapse: collapse;\n																	border-spacing: 0px;\n																"\n																width="100%"\n															>\n																<!-- CODE BLOCK -->\n																<tr>\n																	<td\n																		align="center"\n																		bgcolor="#f2fcff"\n																		class="es-m-p35l es-m-p35r es-m-txt-c"\n																		style="\n																			margin: 0;\n																			padding-top: 25px;\n																			padding-right: 30px;\n																			padding-bottom: 25px;\n																			padding-left: 30px;\n																			border-radius: 1rem;\n																		"\n																	>\n																		<h1\n																			style="\n																				margin: 0;\n																				font-family: roboto,\n																					&quot;helvetica neue&quot;,\n																					helvetica,\n																					arial,\n																					sans-serif;\n																				mso-line-height-rule: exactly;\n																				letter-spacing: 0;\n																				font-size: 30px;\n																				font-style: normal;\n																				font-weight: normal;\n																				line-height: 30px !important;\n																				color: #123533;\n																			"\n																		>\n																			<strong\n																				>{{ code }}</strong\n																			>\n																		</h1>\n																	</td>\n																</tr>\n\n																<tr>\n																	<td\n																		style="\n																			padding-top: 24px;\n																			padding-bottom: 24px;\n																		"\n																	></td>\n																</tr>\n\n																<!-- LICENSE INSTRUCTIONS -->\n																<tr>\n																	<td\n																		align="left"\n																		class="es-m-txt-c"\n																		style="\n																			padding: 0;\n																			margin: 0;\n																			padding-top: 15px;\n																			padding-right: 30px;\n																			padding-left: 30px;\n																		"\n																	>\n																		<p\n																			style="\n																				margin: 0;\n																				mso-line-height-rule: exactly;\n																				font-family: roboto,\n																					&quot;helvetica neue&quot;,\n																					helvetica,\n																					arial,\n																					sans-serif;\n																				line-height: 34px !important;\n																				letter-spacing: 0;\n																				color: #666666;\n																				font-size: 20px;\n																				padding-top: 24px;\n																				font-weight: 500;\n																			"\n																		>\n																			How to Activate your\n																			License<br /><br />\n																		</p>\n																		<p\n																			style="\n																				margin: 0;\n																				mso-line-height-rule: exactly;\n																				font-family: roboto,\n																					&quot;helvetica neue&quot;,\n																					helvetica,\n																					arial,\n																					sans-serif;\n																				line-height: 24px !important;\n																				letter-spacing: 0;\n																				color: #666666;\n																				font-size: 16px;\n																			"\n																		>\n																			1. Download and install\n																			Glimmr:\n																			<a\n																				href="https://glimmr.app/download"\n																				style="\n																					text-decoration: underline;\n																					color: #19bcc2;\n																					font-size: 16px;\n																				"\n																				target="_blank"\n																			>\n																				https://glimmr.app/download </a\n																			><br /><br />\n																			2. Open the app and\n																			navigate to the Settings\n																			page.<br /><br />\n																			3. Scroll down and click\n																			the "Activate"\n																			button.<br /><br />\n																			4. Follow the on-screen\n																			steps to activate your\n																			license. <br /><br />\n																		</p>\n\n																		<p\n																			style="\n																				margin: 0;\n																				mso-line-height-rule: exactly;\n																				font-family: roboto,\n																					&quot;helvetica neue&quot;,\n																					helvetica,\n																					arial,\n																					sans-serif;\n																				line-height: 34px !important;\n																				letter-spacing: 0;\n																				color: #666666;\n																				font-size: 20px;\n																				padding-top: 24px;\n																			"\n																		>\n																			That’s it! If you have\n																			any questions or\n																			concerns feel free to\n																			respond to this email or\n																			send us a new one at\n																			<a\n																				href="mailto:support@glimmr.app"\n																				>support@glimmr.app</a\n																			>.\n																		</p>\n																	</td>\n																</tr>\n\n																<!-- SPACER -->\n																<tr>\n																	<td\n																		align="center"\n																		style="\n																			margin: 0;\n																			padding-right: 20px;\n																			padding-left: 20px;\n																			padding-top: 35px;\n																			padding-bottom: 20px;\n																			font-size: 0;\n																		"\n																	>\n																		<table\n																			border="0"\n																			cellpadding="0"\n																			cellspacing="0"\n																			class="es-spacer"\n																			height="100%"\n																			role="presentation"\n																			style="\n																				mso-table-lspace: 0pt;\n																				mso-table-rspace: 0pt;\n																				border-collapse: collapse;\n																				border-spacing: 0px;\n																			"\n																			width="100%"\n																		>\n																			<tr>\n																				<td\n																					style="\n																						padding: 0;\n																						margin: 0;\n																						border-bottom: 1px\n																							solid\n																							#cccccc;\n																						background: none;\n																						height: 1px;\n																						width: 100%;\n																						margin: 0px;\n																					"\n																				></td>\n																			</tr>\n																		</table>\n																	</td>\n																</tr>\n															</table>\n														</td>\n													</tr>\n												</table>\n											</td>\n										</tr>\n									</table>\n								</td>\n							</tr>\n						</table>\n\n						<!-- SUPPORT / QUESTIONS -->\n						<table\n							align="center"\n							cellpadding="0"\n							cellspacing="0"\n							class="es-content"\n							style="\n								mso-table-lspace: 0pt;\n								mso-table-rspace: 0pt;\n								border-collapse: collapse;\n								border-spacing: 0px;\n								width: 100%;\n								table-layout: fixed !important;\n							"\n						>\n							<tr>\n								<td\n									align="center"\n									bgcolor="transparent"\n									style="padding: 0; margin: 0"\n								>\n									<table\n										align="center"\n										bgcolor="#ffffff"\n										cellpadding="0"\n										cellspacing="0"\n										class="es-content-body"\n										style="\n											mso-table-lspace: 0pt;\n											mso-table-rspace: 0pt;\n											border-collapse: collapse;\n											border-spacing: 0px;\n											background-color: #ffffff;\n											width: 600px;\n										"\n									>\n										<tr>\n											<td\n												align="left"\n												style="\n													padding: 0;\n													margin: 0;\n													padding-top: 20px;\n													padding-right: 20px;\n													padding-left: 20px;\n												"\n											>\n												<table\n													cellpadding="0"\n													cellspacing="0"\n													style="\n														mso-table-lspace: 0pt;\n														mso-table-rspace: 0pt;\n														border-collapse: collapse;\n														border-spacing: 0px;\n													"\n												>\n													<tr>\n														<td\n															align="left"\n															style="\n																padding: 0;\n																margin: 0;\n																width: 560px;\n															"\n														>\n															<table\n																cellpadding="0"\n																cellspacing="0"\n																role="presentation"\n																style="\n																	mso-table-lspace: 0pt;\n																	mso-table-rspace: 0pt;\n																	border-collapse: collapse;\n																	border-spacing: 0px;\n																"\n																width="100%"\n															>\n																<tr>\n																	<td\n																		align="center"\n																		class="es-m-txt-c"\n																		style="\n																			padding: 0;\n																			margin: 0;\n																		"\n																	>\n																		<p\n																			style="\n																				margin: 0;\n																				mso-line-height-rule: exactly;\n																				font-family: roboto,\n																					&quot;helvetica neue&quot;,\n																					helvetica,\n																					arial,\n																					sans-serif;\n																				line-height: 21px;\n																				letter-spacing: 0;\n																				color: #333333;\n																				font-size: 14px;\n																			"\n																		>\n																			Questions? Email us at\n																			<a\n																				href="mailto:support@glimmr.app"\n																				style="\n																					mso-line-height-rule: exactly;\n																					text-decoration: underline;\n																					color: #19bcc2;\n																					font-size: 14px;\n																				"\n																			>\n																				support@glimmr.app\n																			</a>\n																		</p>\n																	</td>\n																</tr>\n															</table>\n														</td>\n													</tr>\n												</table>\n											</td>\n										</tr>\n									</table>\n								</td>\n							</tr>\n						</table>\n\n						<!-- FOOTER SPACER (OPTIONAL) -->\n						<table\n							align="center"\n							cellpadding="0"\n							cellspacing="0"\n							class="es-content"\n							style="\n								mso-table-lspace: 0pt;\n								mso-table-rspace: 0pt;\n								border-collapse: collapse;\n								border-spacing: 0px;\n								width: 100%;\n								table-layout: fixed !important;\n							"\n						>\n							<tr>\n								<td\n									align="center"\n									bgcolor="transparent"\n									style="padding: 0; margin: 0"\n								>\n									<table\n										align="center"\n										bgcolor="#ffffff"\n										cellpadding="0"\n										cellspacing="0"\n										class="es-content-body"\n										style="\n											mso-table-lspace: 0pt;\n											mso-table-rspace: 0pt;\n											border-collapse: collapse;\n											border-spacing: 0px;\n											background-color: #ffffff;\n											width: 600px;\n										"\n									>\n										<tr>\n											<td\n												align="left"\n												style="\n													padding: 0;\n													margin: 0;\n													padding-top: 20px;\n													padding-right: 20px;\n													padding-left: 20px;\n												"\n											>\n												<table\n													cellpadding="0"\n													cellspacing="0"\n													style="\n														mso-table-lspace: 0pt;\n														mso-table-rspace: 0pt;\n														border-collapse: collapse;\n														border-spacing: 0px;\n													"\n												>\n													<tr>\n														<td\n															align="left"\n															style="\n																padding: 0;\n																margin: 0;\n																width: 560px;\n															"\n														>\n															<table\n																cellpadding="0"\n																cellspacing="0"\n																style="\n																	mso-table-lspace: 0pt;\n																	mso-table-rspace: 0pt;\n																	border-collapse: collapse;\n																	border-spacing: 0px;\n																"\n																width="100%"\n															>\n																<tr>\n																	<td\n																		align="center"\n																		style="\n																			padding: 0;\n																			margin: 0;\n																			display: none;\n																		"\n																	></td>\n																</tr>\n															</table>\n														</td>\n													</tr>\n												</table>\n											</td>\n										</tr>\n									</table>\n								</td>\n							</tr>\n						</table>\n					</td>\n				</tr>\n			</table>\n		</div>\n	</body>\n</html>\n';
const reviewRequestTemplate = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html lang="en" xmlns="http://www.w3.org/1999/xhtml">
	<head>
		<meta charset="UTF-8" />
		<meta content="width=device-width, initial-scale=1" name="viewport" />
		<meta name="x-apple-disable-message-reformatting" />
		<meta content="IE=edge" http-equiv="X-UA-Compatible" />
		<meta content="telephone=no" name="format-detection" />
		<title>New message</title>
		<!--[if (mso 16)]>
			<style type="text/css">
				a {
					text-decoration: none;
				}
			</style>
		<![endif]-->
		<!--[if gte mso 9]>
			<style>
				sup {
					font-size: 100% !important;
				}
			</style><!
		[endif]-->
		<!--[if gte mso 9]>
			<xml>
				<o:OfficeDocumentSettings>
					<o:AllowPNG></o:AllowPNG>
					<o:PixelsPerInch>96</o:PixelsPerInch>
				</o:OfficeDocumentSettings>
			</xml>
		<![endif]-->
		<!--[if !mso]>-->
		<link
			href="https://fonts.googleapis.com/css?family=Roboto:400,400i,700,700i"
			rel="stylesheet"
		/>
		<!--<![endif]-->
		<style type="text/css">
			.rollover:hover .rollover-first {
				max-height: 0 !important;
				display: none !important;
			}

			.rollover:hover .rollover-second {
				max-height: none !important;
				display: inline-block !important;
			}

			.rollover div {
				font-size: 0px;
			}

			u ~ div img + div > div {
				display: none;
			}

			#outlook a {
				padding: 0;
			}

			span.MsoHyperlink,
			span.MsoHyperlinkFollowed {
				color: inherit;
				mso-style-priority: 99;
			}

			a.es-button {
				mso-style-priority: 100 !important;
				text-decoration: none !important;
			}

			a[x-apple-data-detectors] {
				color: inherit !important;
				text-decoration: none !important;
				font-size: inherit !important;
				font-family: inherit !important;
				font-weight: inherit !important;
				line-height: inherit !important;
			}

			.es-desk-hidden {
				display: none;
				float: left;
				overflow: hidden;
				width: 0;
				max-height: 0;
				line-height: 0;
				mso-hide: all;
			}

			/*
  .es-header-body a:hover {
	color:#2cb543!important;
	}
  */
			/*
  .es-content-body a:hover {
	color:#2cb543!important;
	}
  */
			/*
  .es-footer-body a:hover {
	color:#ffffff!important;
	}
  */
			/*
  .es-infoblock a:hover {
	color:#cccccc!important;
	}
  */
			.es-button-border:hover {
				border-color: #42d159 #42d159 #42d159 #42d159 !important;
				background: #56d66b !important;
			}

			.es-button-border:hover a.es-button,
			.es-button-border:hover button.es-button {
				background: #56d66b !important;
			}

			@media only screen and (max-width: 600px) {
				.es-m-p35r {
					padding-right: 35px !important;
				}

				.es-m-p35l {
					padding-left: 35px !important;
				}

				*[class="gmail-fix"] {
					display: none !important;
				}

				p,
				a {
					line-height: 150% !important;
				}

				h1,
				h1 a {
					line-height: 120% !important;
				}

				h2,
				h2 a {
					line-height: 120% !important;
				}

				h3,
				h3 a {
					line-height: 120% !important;
				}

				h4,
				h4 a {
					line-height: 120% !important;
				}

				h5,
				h5 a {
					line-height: 120% !important;
				}

				h6,
				h6 a {
					line-height: 120% !important;
				}

				.es-header-body p {
				}

				.es-content-body p {
				}

				.es-footer-body p {
				}

				.es-infoblock p {
				}

				h1 {
					font-size: 30px !important;
					text-align: left;
				}

				h2 {
					font-size: 24px !important;
					text-align: left;
				}

				h3 {
					font-size: 20px !important;
					text-align: left;
				}

				h4 {
					font-size: 24px !important;
					text-align: left;
				}

				h5 {
					font-size: 20px !important;
					text-align: left;
				}

				h6 {
					font-size: 16px !important;
					text-align: left;
				}

				.es-header-body h1 a,
				.es-content-body h1 a,
				.es-footer-body h1 a {
					font-size: 30px !important;
				}

				.es-header-body h2 a,
				.es-content-body h2 a,
				.es-footer-body h2 a {
					font-size: 24px !important;
				}

				.es-header-body h3 a,
				.es-content-body h3 a,
				.es-footer-body h3 a {
					font-size: 20px !important;
				}

				.es-header-body h4 a,
				.es-content-body h4 a,
				.es-footer-body h4 a {
					font-size: 24px !important;
				}

				.es-header-body h5 a,
				.es-content-body h5 a,
				.es-footer-body h5 a {
					font-size: 20px !important;
				}

				.es-header-body h6 a,
				.es-content-body h6 a,
				.es-footer-body h6 a {
					font-size: 16px !important;
				}

				.es-menu td a {
					font-size: 14px !important;
				}

				.es-header-body p,
				.es-header-body a {
					font-size: 14px !important;
				}

				.es-content-body p,
				.es-content-body a {
					font-size: 14px !important;
				}

				.es-footer-body p,
				.es-footer-body a {
					font-size: 14px !important;
				}

				.es-infoblock p,
				.es-infoblock a {
					font-size: 12px !important;
				}

				.es-m-txt-c,
				.es-m-txt-c h1,
				.es-m-txt-c h2,
				.es-m-txt-c h3,
				.es-m-txt-c h4,
				.es-m-txt-c h5,
				.es-m-txt-c h6 {
					text-align: center !important;
				}

				.es-m-txt-r,
				.es-m-txt-r h1,
				.es-m-txt-r h2,
				.es-m-txt-r h3,
				.es-m-txt-r h4,
				.es-m-txt-r h5,
				.es-m-txt-r h6 {
					text-align: right !important;
				}

				.es-m-txt-j,
				.es-m-txt-j h1,
				.es-m-txt-j h2,
				.es-m-txt-j h3,
				.es-m-txt-j h4,
				.es-m-txt-j h5,
				.es-m-txt-j h6 {
					text-align: justify !important;
				}

				.es-m-txt-l,
				.es-m-txt-l h1,
				.es-m-txt-l h2,
				.es-m-txt-l h3,
				.es-m-txt-l h4,
				.es-m-txt-l h5,
				.es-m-txt-l h6 {
					text-align: left !important;
				}

				.es-m-txt-r img,
				.es-m-txt-c img,
				.es-m-txt-l img,
				.es-m-txt-r .rollover:hover .rollover-second,
				.es-m-txt-c .rollover:hover .rollover-second,
				.es-m-txt-l .rollover:hover .rollover-second {
					display: inline !important;
				}

				.es-m-txt-r .rollover div,
				.es-m-txt-c .rollover div,
				.es-m-txt-l .rollover div {
					line-height: 0 !important;
					font-size: 0 !important;
				}

				.es-spacer {
					display: inline-table;
				}

				a.es-button,
				button.es-button {
					font-size: 18px !important;
				}

				.es-m-fw,
				.es-m-fw.es-fw,
				.es-m-fw .es-button {
					display: block !important;
				}

				.es-m-il,
				.es-m-il .es-button,
				.es-social,
				.es-social td,
				.es-menu {
					display: inline-block !important;
				}

				.es-adaptive table,
				.es-left,
				.es-right {
					width: 100% !important;
				}

				.es-content table,
				.es-header table,
				.es-footer table,
				.es-content,
				.es-footer,
				.es-header {
					width: 100% !important;
					max-width: 600px !important;
				}

				.adapt-img:not([src*="default-img"]) {
					width: 100% !important;
					height: auto !important;
				}

				.es-mobile-hidden,
				.es-hidden {
					display: none !important;
				}

				.es-desk-hidden {
					width: auto !important;
					overflow: visible !important;
					float: none !important;
					max-height: inherit !important;
					line-height: inherit !important;
				}

				tr.es-desk-hidden {
					display: table-row !important;
				}

				table.es-desk-hidden {
					display: table !important;
				}

				td.es-desk-menu-hidden {
					display: table-cell !important;
				}

				.es-menu td {
					width: 1% !important;
				}

				table.es-table-not-adapt,
				.esd-block-html table {
					width: auto !important;
				}

				.es-social td {
					padding-bottom: 10px;
				}

				.es-text-3309,
				.es-text-3309 p,
				.es-text-3309 a,
				.es-text-3309 h1,
				.es-text-3309 h2,
				.es-text-3309 h3,
				.es-text-3309 h4,
				.es-text-3309 h5,
				.es-text-3309 h6,
				.es-text-3309 ul,
				.es-text-3309 ol {
					font-size: 20px !important;
				}

				a.es-button,
				button.es-button {
					display: inline-block !important;
				}

				.es-button-border {
					display: inline-block !important;
				}
			}
		</style>
	</head>
	<body style="width: 100%; height: 100%; padding: 0; margin: 0">
		<div class="es-wrapper-color" style="background-color: #ffffff">
			<!--[if gte mso 9]>
				<v:background xmlns:v="urn:schemas-microsoft-com:vml" fill="t">
					<v:fill type="tile" color="#FFFFFF"></v:fill>
				</v:background>
			<![endif]-->
			<table
				cellpadding="0"
				cellspacing="0"
				class="es-wrapper"
				style="
					mso-table-lspace: 0pt;
					mso-table-rspace: 0pt;
					border-collapse: collapse;
					border-spacing: 0px;
					padding: 0;
					margin: 0;
					width: 100%;
					height: 100%;
					background-repeat: repeat;
					background-position: center top;
					background-color: #ffffff;
				"
				width="100%"
			>
				<tr>
					<td style="padding: 0; margin: 0" valign="top">
						<table
							align="center"
							cellpadding="0"
							cellspacing="0"
							class="es-content"
							style="
								mso-table-lspace: 0pt;
								mso-table-rspace: 0pt;
								border-collapse: collapse;
								border-spacing: 0px;
								width: 100%;
								table-layout: fixed !important;
							"
						>
							<tr>
								<td
									align="center"
									bgcolor="transparent"
									style="padding: 0; margin: 0"
								>
									<table
										align="center"
										bgcolor="#ffffff"
										cellpadding="0"
										cellspacing="0"
										class="es-content-body"
										style="
											mso-table-lspace: 0pt;
											mso-table-rspace: 0pt;
											border-collapse: collapse;
											border-spacing: 0px;
											background-color: #ffffff;
											width: 600px;
										"
									>
										<tr>
											<td
												align="left"
												style="
													padding: 0;
													margin: 0;
													padding-top: 20px;
													padding-right: 20px;
													padding-left: 20px;
												"
											>
												<table
													cellpadding="0"
													cellspacing="0"
													style="
														mso-table-lspace: 0pt;
														mso-table-rspace: 0pt;
														border-collapse: collapse;
														border-spacing: 0px;
													"
												>
													<tr>
														<td
															align="left"
															style="
																padding: 0;
																margin: 0;
																width: 560px;
															"
														>
															<table
																cellpadding="0"
																cellspacing="0"
																role="presentation"
																style="
																	mso-table-lspace: 0pt;
																	mso-table-rspace: 0pt;
																	border-collapse: collapse;
																	border-spacing: 0px;
																"
																width="100%"
															>
																<tr>
																	<td
																		align="center"
																		style="
																			padding: 0;
																			margin: 0;
																			padding-top: 5px;
																			padding-bottom: 10px;
																			font-size: 0;
																		"
																	>
																		<img
																			alt=""
																			src="https://glimmr.app/images/icon.png"
																			style="
																				display: block;
																				font-size: 14px;
																				border: 0;
																				outline: none;
																				text-decoration: none;
																				border-radius: 50px;
																			"
																			width="100"
																		/>
																	</td>
																</tr>
																<tr>
																	<td
																		align="center"
																		style="
																			padding: 20px;
																			margin: 0;
																			font-size: 0;
																		"
																	>
																		<table
																			border="0"
																			cellpadding="0"
																			cellspacing="0"
																			class="es-spacer"
																			height="100%"
																			role="presentation"
																			style="
																				mso-table-lspace: 0pt;
																				mso-table-rspace: 0pt;
																				border-collapse: collapse;
																				border-spacing: 0px;
																			"
																			width="100%"
																		>
																			<tr>
																				<td
																					style="
																						padding: 0;
																						margin: 0;
																						border-bottom: 1px
																							solid
																							#cccccc;
																						background: none;
																						height: 1px;
																						width: 100%;
																						margin: 0px;
																					"
																				></td>
																			</tr>
																		</table>
																	</td>
																</tr>
															</table>
														</td>
													</tr>
												</table>
											</td>
										</tr>
									</table>
								</td>
							</tr>
						</table>
						<table
							align="center"
							cellpadding="0"
							cellspacing="0"
							class="es-content"
							style="
								mso-table-lspace: 0pt;
								mso-table-rspace: 0pt;
								border-collapse: collapse;
								border-spacing: 0px;
								width: 100%;
								table-layout: fixed !important;
							"
						>
							<tr>
								<td
									align="center"
									bgcolor="transparent"
									style="padding: 0; margin: 0"
								>
									<table
										align="center"
										bgcolor="#ffffff"
										cellpadding="0"
										cellspacing="0"
										class="es-content-body"
										style="
											mso-table-lspace: 0pt;
											mso-table-rspace: 0pt;
											border-collapse: collapse;
											border-spacing: 0px;
											background-color: #ffffff;
											width: 600px;
										"
									>
										<tr>
											<td
												align="left"
												style="
													padding: 0;
													margin: 0;
													padding-top: 20px;
													padding-right: 20px;
													padding-left: 20px;
												"
											>
												<table
													cellpadding="0"
													cellspacing="0"
													style="
														mso-table-lspace: 0pt;
														mso-table-rspace: 0pt;
														border-collapse: collapse;
														border-spacing: 0px;
													"
												>
													<tr>
														<td
															align="left"
															style="
																padding: 0;
																margin: 0;
																width: 560px;
															"
														>
															<table
																cellpadding="0"
																cellspacing="0"
																role="presentation"
																style="
																	mso-table-lspace: 0pt;
																	mso-table-rspace: 0pt;
																	border-collapse: collapse;
																	border-spacing: 0px;
																"
																width="100%"
															>
																<tr>
																	<td
																		align="center"
																		class="es-m-txt-c"
																		style="
																			padding: 0;
																			margin: 0;
																		"
																	>
																		<h2
																			style="
																				margin: 0;
																				font-family: roboto,
																					&quot;helvetica neue&quot;,
																					helvetica,
																					arial,
																					sans-serif;
																				mso-line-height-rule: exactly;
																				letter-spacing: 0;
																				font-size: 24px;
																				font-style: normal;
																				font-weight: normal;
																				line-height: 29px;
																				color: #333333;
																			"
																		>
																			<strong
																				>Your opinion matters!</strong
																			>
																		</h2>
																	</td>
																</tr>
															</table>
														</td>
													</tr>
													<tr>
														<td
															align="left"
															style="
																padding: 0;
																margin: 0;
																width: 560px;
															"
														>
															<table
																cellpadding="0"
																cellspacing="0"
																role="presentation"
																style="
																	mso-table-lspace: 0pt;
																	mso-table-rspace: 0pt;
																	border-collapse: collapse;
																	border-spacing: 0px;
																"
																width="100%"
															>
																<tr>
																	<td
																		align="center"
																		class="es-text-3309 es-m-txt-c"
																		style="
																			padding: 0;
																			margin: 0;
																			padding-top: 5px;
																			font-size: 20px;
																		"
																	>
																		<p
																			style="
																				margin: 0;
																				mso-line-height-rule: exactly;
																				font-family: roboto,
																					&quot;helvetica neue&quot;,
																					helvetica,
																					arial,
																					sans-serif;
																				line-height: 34px !important;
																				letter-spacing: 0;
																				color: #666666;
																				font-size: 16px;
																			"
																		>
																			Hi {{ customer }},
																		</p>
																		<p
																			style="
																				margin: 0;
																				mso-line-height-rule: exactly;
																				font-family: roboto,
																					&quot;helvetica neue&quot;,
																					helvetica,
																					arial,
																					sans-serif;
																				line-height: 34px !important;
																				letter-spacing: 0;
																				color: #666666;
																				font-size: 16px;
																			"
																		>
																			We hope you're enjoying Glimmr! We would love to hear about your experience.
																		</p>
																		<p style="
																				margin: 0;
																				mso-line-height-rule: exactly;
																				font-family: roboto,
																					&quot;helvetica neue&quot;,
																					helvetica,
																					arial,
																					sans-serif;
																				line-height: 34px !important;
																				letter-spacing: 0;
																				color: #666666;
																				font-size: 16px;
																			">
																			Your opinion matters to us, as it helps us improve our product and provide you with the best possible experience. Click the link below to drop us a review!
																		</p>
																	</td>
																</tr>
															</table>
														</td>
													</tr>
												</table>
											</td>
										</tr>
									</table>
								</td>
							</tr>
						</table>
						<table
							align="center"
							cellpadding="0"
							cellspacing="0"
							class="es-content"
							style="
								mso-table-lspace: 0pt;
								mso-table-rspace: 0pt;
								border-collapse: collapse;
								border-spacing: 0px;
								width: 100%;
								table-layout: fixed !important;
							"
						>
							<tr>
								<td
									align="center"
									bgcolor="transparent"
									style="padding: 0; margin: 0"
								>
									<table
										align="center"
										bgcolor="#ffffff"
										cellpadding="0"
										cellspacing="0"
										class="es-content-body"
										style="
											mso-table-lspace: 0pt;
											mso-table-rspace: 0pt;
											border-collapse: collapse;
											border-spacing: 0px;
											background-color: #ffffff;
											width: 600px;
										"
									>
										<tr>
											<td
												align="left"
												style="
													padding: 0;
													margin: 0;
													padding-top: 20px;
													padding-right: 20px;
													padding-left: 20px;
												"
											>
												<table
													align="right"
													cellpadding="0"
													cellspacing="0"
													class="es-right"
													style="
														mso-table-lspace: 0pt;
														mso-table-rspace: 0pt;
														border-collapse: collapse;
														border-spacing: 0px;
														float: right;
													"
												>
													<tr>
														<td
															align="left"
															style="
																padding: 0;
																margin: 0;
																width: 560px;
															"
														>
															<table
																cellpadding="0"
																cellspacing="0"
																role="presentation"
																style="
																	mso-table-lspace: 0pt;
																	mso-table-rspace: 0pt;
																	border-collapse: collapse;
																	border-spacing: 0px;
																"
																width="100%"
															>
																<tr>
																	<td
																		align="center"
																		bgcolor="#FFFFFF"
																		class="es-m-p35l es-m-p35r es-m-txt-c"
																		style="
																			margin: 0;
																			padding-top: 25px;
																			padding-right: 30px;
																			padding-bottom: 25px;
																			padding-left: 30px;
																			border-radius: 1rem;
																		"
																	>
																		<a href="https://g.page/r/CW9kAXiF6U8FEAE/review">
																			<img src="https://ccoe.us/wp-content/uploads/2021/02/Google-Review-Button.png" width="256"/>
																		</a>
																	</td>
																</tr>
																<tr>
																	<td align="center">
																		<a style="
																				margin: 0;
																				mso-line-height-rule: exactly;
																				font-family: roboto,
																					&quot;helvetica neue&quot;,
																					helvetica,
																					arial,
																					sans-serif;
																				line-height: 36px;
																				letter-spacing: 0;
																				color: #333333;
																				font-size: 14px;
																				text-align: center;
																			" href="https://g.page/r/CW9kAXiF6U8FEAE/review">
																			Or click here to leave a review.
																		</a>
																	</td>
																</tr>
																<tr>
																	<td
																		align="center"
																		style="
																			margin: 0;
																			padding-right: 20px;
																			padding-left: 20px;
																			padding-top: 35px;
																			padding-bottom: 20px;
																			font-size: 0;
																		"
																	>
																		<table
																			border="0"
																			cellpadding="0"
																			cellspacing="0"
																			class="es-spacer"
																			height="100%"
																			role="presentation"
																			style="
																				mso-table-lspace: 0pt;
																				mso-table-rspace: 0pt;
																				border-collapse: collapse;
																				border-spacing: 0px;
																			"
																			width="100%"
																		>
																			<tr>
																				<td
																					style="
																						padding: 0;
																						margin: 0;
																						border-bottom: 1px
																							solid
																							#cccccc;
																						background: none;
																						height: 1px;
																						width: 100%;
																						margin: 0px;
																					"
																				></td>
																			</tr>
																		</table>
																	</td>
																</tr>
															</table>
														</td>
													</tr>
												</table>
											</td>
										</tr>
									</table>
								</td>
							</tr>
						</table>
						<table
							align="center"
							cellpadding="0"
							cellspacing="0"
							class="es-content"
							style="
								mso-table-lspace: 0pt;
								mso-table-rspace: 0pt;
								border-collapse: collapse;
								border-spacing: 0px;
								width: 100%;
								table-layout: fixed !important;
							"
						>
							<tr>
								<td
									align="center"
									bgcolor="transparent"
									style="padding: 0; margin: 0"
								>
									<table
										align="center"
										bgcolor="#ffffff"
										cellpadding="0"
										cellspacing="0"
										class="es-content-body"
										style="
											mso-table-lspace: 0pt;
											mso-table-rspace: 0pt;
											border-collapse: collapse;
											border-spacing: 0px;
											background-color: #ffffff;
											width: 600px;
										"
									>
										<tr>
											<td
												align="left"
												style="
													padding: 0;
													margin: 0;
													padding-top: 20px;
													padding-right: 20px;
													padding-left: 20px;
												"
											>
												<table
													cellpadding="0"
													cellspacing="0"
													style="
														mso-table-lspace: 0pt;
														mso-table-rspace: 0pt;
														border-collapse: collapse;
														border-spacing: 0px;
													"
												>
													<tr>
														<td
															align="left"
															style="
																padding: 0;
																margin: 0;
																width: 560px;
															"
														>
															<table
																cellpadding="0"
																cellspacing="0"
																role="presentation"
																style="
																	mso-table-lspace: 0pt;
																	mso-table-rspace: 0pt;
																	border-collapse: collapse;
																	border-spacing: 0px;
																"
																width="100%"
															>
																<tr>
																	<td
																		align="center"
																		class="es-m-txt-c"
																		style="
																			padding: 0;
																			margin: 0;
																		"
																	>
																		<p
																			style="
																				margin: 0;
																				mso-line-height-rule: exactly;
																				font-family: roboto,
																					&quot;helvetica neue&quot;,
																					helvetica,
																					arial,
																					sans-serif;
																				line-height: 21px;
																				letter-spacing: 0;
																				color: #333333;
																				font-size: 14px;
																			"
																		>
																			Questions? Email us at
																			<a
																				href="mailto:support@glimmr.app"
																				style="
																					mso-line-height-rule: exactly;
																					text-decoration: underline;
																					color: #19bcc2;
																					font-size: 14px;
																				"
																				>support@glimmr.app</a
																			>
																		</p>
																	</td>
																</tr>
																<tr>
																	<td align="center"
																	    class="es-m-txt-c"
																	    style="
																			padding: 0;
																			margin: 0;
																		">
																		<p style="
																				margin: 0;
																				mso-line-height-rule: exactly;
																				font-family: roboto,
																					&quot;helvetica neue&quot;,
																					helvetica,
																					arial,
																					sans-serif;
																				line-height: 21px;
																				letter-spacing: 0;
																				color: #333333;
																				font-size: 14px;
																			">
																			{{{ pm:unsubscribe }}}
																		</p>
																	</td>
																</tr>
															</table>
														</td>
													</tr>
												</table>
											</td>
										</tr>
									</table>
								</td>
							</tr>
						</table>
						<table
							align="center"
							cellpadding="0"
							cellspacing="0"
							class="es-content"
							style="
								mso-table-lspace: 0pt;
								mso-table-rspace: 0pt;
								border-collapse: collapse;
								border-spacing: 0px;
								width: 100%;
								table-layout: fixed !important;
							"
						>
							<tr>
								<td
									align="center"
									bgcolor="transparent"
									style="padding: 0; margin: 0"
								>
									<table
										align="center"
										bgcolor="#ffffff"
										cellpadding="0"
										cellspacing="0"
										class="es-content-body"
										style="
											mso-table-lspace: 0pt;
											mso-table-rspace: 0pt;
											border-collapse: collapse;
											border-spacing: 0px;
											background-color: #ffffff;
											width: 600px;
										"
									>
										<tr>
											<td
												align="left"
												style="
													padding: 0;
													margin: 0;
													padding-top: 20px;
													padding-right: 20px;
													padding-left: 20px;
												"
											>
												<table
													cellpadding="0"
													cellspacing="0"
													style="
														mso-table-lspace: 0pt;
														mso-table-rspace: 0pt;
														border-collapse: collapse;
														border-spacing: 0px;
													"
												>
													<tr>
														<td
															align="left"
															style="
																padding: 0;
																margin: 0;
																width: 560px;
															"
														>
															<table
																cellpadding="0"
																cellspacing="0"
																style="
																	mso-table-lspace: 0pt;
																	mso-table-rspace: 0pt;
																	border-collapse: collapse;
																	border-spacing: 0px;
																"
																width="100%"
															>
																<tr>
																	<td
																		align="center"
																		style="
																			padding: 0;
																			margin: 0;
																			display: none;
																		"
																	></td>
																</tr>
															</table>
														</td>
													</tr>
												</table>
											</td>
										</tr>
									</table>
								</td>
							</tr>
						</table>
					</td>
				</tr>
			</table>
		</div>
	</body>
</html>
`;
const postmarkClient = new postmark.ServerClient(POSTMARK_SERVER_TOKEN);
const defaultOptions = {
  from: SMTP_FROM,
  headers: {
    "X-Face": PUBLIC_ICON_URL,
    "X-Image-URL": PUBLIC_ICON_URL
  }
};
const getEmailVerificationConfig = (email, code) => ({
  to: email,
  subject: "Your single-use code",
  html: emailVerificationTemplate.replace("{{ code }}", code),
  ...defaultOptions
});
const getLicenseVerifiedConfig = (email) => ({
  to: email,
  bcc: "glimmr.app+98972a7044@invite.trustpilot.com",
  subject: "License verified",
  html: licenseVerifiedTemplate,
  ...defaultOptions
});
const getLicenseConfig = (email, code, intro = "") => ({
  to: email,
  subject: "Your new license",
  html: licenseTemplate.replace("{{ code }}", code).replace("{{ intro }}", intro),
  ...defaultOptions
});
const getReviewRequestConfig = (email, customer) => ({
  to: email,
  subject: "What do you think about Glimmr?",
  html: reviewRequestTemplate.replace("{{ customer }}", customer),
  ...defaultOptions
});
const getBugReportConfig = (title, description, machine) => {
  const data = {
    description,
    machine
  };
  const finalTitle = title ?? "Untitled";
  const subject = `[BUG REPORT] : ${finalTitle}`;
  const text = JSON.stringify(data);
  return {
    to: SMTP_USER,
    subject,
    text,
    ...defaultOptions
  };
};
const toPostmarkConfig = (options) => ({
  From: options.from,
  To: options.to,
  Subject: options.subject,
  HtmlBody: options.html,
  TextBody: options.text
});
const sendMail = async (options) => {
  return postmarkClient.sendEmail(toPostmarkConfig(options));
};
const sendLicenseVerifiedEmail = async (email) => {
  return sendMail(getLicenseVerifiedConfig(email));
};
const sendEmailVerification = async (email, code) => {
  return sendMail(getEmailVerificationConfig(email, code));
};
const sendLicenseEmail = (email, code, intro) => {
  return sendMail(getLicenseConfig(email, code, intro));
};
const sendBugReport = async (title, description, machine) => {
  const options = getBugReportConfig(title, description, machine);
  return sendMail(options);
};
export {
  sendBugReport as a,
  sendLicenseVerifiedEmail as b,
  sendEmailVerification as c,
  getReviewRequestConfig as g,
  postmarkClient as p,
  sendLicenseEmail as s,
  toPostmarkConfig as t
};
